import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DashboardService } from '../../.../../../services/dashboard/dashboard.service';
import { CommonService } from '../../../services/common/common.service';
import { LandingpageService } from '../../../services/landingpage/landingpage.service';
import { GtsService } from "src/app/services/gts/gts.service";
import { ExcelService } from '../../../services/dashboard/excel/excel.service';
import { Workbook } from 'exceljs';
import * as fs from 'file-saver';
import * as moment from 'moment';
import { LeaderboardService } from 'src/app/services/leaderboard.service';
import { UserActivitiesService } from 'src/app/services/user-activities.service';
// import { collectExternalReferences } from '@angular/compiler';
import { UserDashboardService } from '../../../services/user-dashboard/user-dashboard.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';

@Component({
  selector: 'app-export-popup',
  templateUrl: './export-popup.component.html',
  styleUrls: ['./export-popup.component.scss']
})
export class ExportPopupComponent implements OnInit {
  @Input() apiData;
  @Input() exportInfo;
  @Input() exportData;
  @Input() access;
  @Input() title;
  @Input() isCollabtic;
  @Input() exportAllFlag;
  @Input() dealerCode: string = '';
  @Input() dealerCodeArr: any = [];
  @Input() branchReport: boolean = false;
  @Input() dealerUserReport: boolean = false;
  @Input() employeeReport: boolean = false;
  @Input() scanReportFlag: boolean = false;
  @Input() salesType1ReportFlag: boolean = false;
  @Input() salesType2ReportFlag: boolean = false;
  @Input() arAgingFlag: boolean = false;
  @Input() currDateTime: any ='';
  @Output() updateonExportisDone = new EventEmitter<any>();
  @Input() serviceRecordType: any = '';
  @Input() serviceRecordObjData: any = '';

  public totalLimit = 0;
  public itemLimit = 20;
  public itemOffset = 0;
  
  public sNo = 0;
  public uploadFlag;
  public itemLength;
  public progressbarCount = "1";
  public progressbarCountWidth = "";
  public stopexportapi: boolean = true;
  public threadLists = [];
  public dealerData = [];
  public leaderInfo: any = [];
  public dtcInfo: any = [];
  public diagnosticInfo: any = [];
  public adasInfo: any = [];
  public exceldownloadtrue: boolean = false;
  public downloadtextflag = 'Exporting data to Excel..';
  public userActivitiesInfo: any = [];
  public firstTimeCall: any = 1;
  public firstData: any = [];
  public userDashLists: any = [];
  public roList: any = [];
  public usageTextStr: string = 'usage report';
  public downloadUrl: string = '';
  public downloadUrlFlag: boolean = false;
  public resSuccess: boolean = false;
  public resSuccessText: string = '';
  constructor(
    private router: Router,
    private leaderBoardApi: LeaderboardService,
    private dashboardApi: DashboardService,
    private excelService: ExcelService,
    private commonService: CommonService,
    private LandingpagewidgetsAPI: LandingpageService,
    private modalService: NgbModal,
    private userActiviesApi: UserActivitiesService,
    private gtsListingApi: GtsService,
    private userDashboardApi: UserDashboardService,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit() {
    console.log(this.access)
    this.sNo = 0;
    switch (this.access) {
      case 'gtsDealer':
        this.apiData['exportAction'] = 0;
        this.apiData['filterOptions']['groupId'] = 162;
        this.exportDealerActivity();
        break;
      case 'summary-job-report':
        this.itemLimit = 50;
        this.exportSummaryJobReport();
        break;
      case 'ro-report':
        this.itemLimit = 50;
        this.exportRoReport();
        break;
      case 'ro-report-filter':
        this.itemOffset = 0;
        this.itemLimit = 50;
        this.exportRoReportFilter();
        break;
      case 'sales-report':
        this.itemOffset = 0;
        this.itemLimit = 50;
        this.exportSalesReport();
        break;
      case 'summary-today':
        this.exportSummaryData();
        break;
      case 'techsupport-tickets':
        this.exportTechSupportTickets();
        break;
      case 'thread-solr-export':
        this.exportSolrThreadData();
        break;
      case 'thread-solr-export-new':
        this.exportSolrThreadDataNew();
        break;
      case 'export-business':
        this.exportBusinessData();
        break;
      case 'export-sr':
        this.exportServiceRecords();
        break;
      case 'summary-weekly':
        this.exportSummaryWeeklyData();
        break;
      case 'gbb-jobs':
        this.exportJOBSData();
        break;
      case 'gbb-jobs-type-4':
        this.exportJOBSType4Data();
        break;
      case 'dealerUsage-export':
        this.usageTextStr = this.title;
        this.exportDealerUsageSolr();
        break;
      case 'dealerUsage':
      case 'serviceProbing':
        if(this.employeeReport){
          this.usageTextStr = "Dealer Code: "+this.dealerCode;
          //this.exportEmployeeActivity();
          this.exportDealerUsageSolr();
        }
        else if(this.dealerUserReport){
          this.usageTextStr = "Dealer Code: "+this.dealerCodeArr;
          //this.exportDealerActivity();
          this.exportDealerUsageSolr();
        }
        /*else{
          this.usageTextStr = this.title;
          this.exportDealerUsageSolr();
        }*/
        break;
      case 'threads':
        if (this.exportAllFlag) {
          this.getexceldata();
        }
        else {
          this.getexceldataThread();
        }
        break;
      case 'leaderboard':
        this.getexceldataLeaderBoard()
        break;
      case 'user-activities':
        this.getexceldataUserActivities()
        break;
      case 'gts':
        this.getGTSExcelData();
        break;
      case 'user-dashboard':
        if(this.apiData["domainId"]==52)
        {
          this.itemLimit=200;
        }
        
        this.getUserDashboard();
        break;
      case 'dtc':
        this.getDTCExcelData();
        break;
      case 'dtc-template':
        this.exceldownloadtrue = true;
        this.exportDTCReport(this.access, this.exportInfo, this.exportData);
        break;
      case 'diagnostic':
        this.getDiagnosticExcelData();
        break;
      case 'diagnostic-template':
        this.exceldownloadtrue = true;
        this.exportDiagnosticReport(this.access, this.exportInfo, this.exportData);
        break;
      case 'adas':
        this.getAdasExcelData();
        break;
      case 'adas-template':
        this.exceldownloadtrue = true;
        this.exportAdasReport(this.access, this.exportInfo, this.exportData);
        break;
      case 'customer-template':
        this.exceldownloadtrue = true;
        this.exportCustomersReport(this.exportInfo);
        break;
      case 'gbb-gts-report':
        this.exportGBBGtsReport();
        break;
    }
  }

  getexceldata() {
    this.apiData['limit'] = this.itemLimit;
    this.apiData['offset'] = this.itemOffset;
    this.apiData['exportAll'] = 1;
    this.apiData['exportLazy'] = 1;

    //alert(JSON.stringify(this.apiData));
    console.log(this.apiData);
    this.uploadFlag = this.dashboardApi.apiChartDetailAll(this.apiData).subscribe((response) => {
      //alert(11);
      let responseData = response.data;
      let total_count = responseData.total;
      this.totalLimit = total_count;
      let exportThreadData = responseData.chartdetails;
      let threadType = this.exportInfo[1];
      let threadInfo = ['exportThread'];
      let threadList;
      console.log(this.isCollabtic);
      if(this.isCollabtic){
        threadList = this.commonService.getModifiedThreadDataOld(threadInfo, exportThreadData, threadType);
      }
      else{
        threadList = this.commonService.getModifiedThreadData(threadInfo, exportThreadData, threadType);
      }
      this.exportData['threadList'] = threadList;

      this.itemLength += total_count;
      this.itemOffset += this.itemLimit;
      this.progressbarCount = ((this.itemOffset / total_count) * 100).toFixed(0);
      this.progressbarCountWidth = this.progressbarCount + '%';
      if (total_count == 0) {
      }
      else {
        if (this.stopexportapi) {
          if (this.itemOffset >= this.totalLimit) {
            this.exceldownloadtrue = true;;
          }
          this.generateExcel(this.access, this.exportInfo, this.exportData);
        }
        if (this.itemOffset >= this.totalLimit) {
          this.stopexportapi = false;
        }
      }
    });
  }

  getexceldataLeaderBoard1() {
    this.apiData['limit'] = this.leaderBoardApi.offset;
    this.apiData['offset'] = 0;
    this.apiData['exportAll'] = 0;
    this.leaderBoardApi.getLeaderBoardChartData(this.apiData).subscribe(response => {
      this.itemLength += response.total;
      this.itemOffset += this.itemLimit;
      this.progressbarCount = ((this.itemOffset / response.total) * 100).toFixed(0);
      this.progressbarCountWidth = this.progressbarCount + '%';
      if (response.total != 0) {
        if (this.stopexportapi) {
          if (this.itemOffset >= this.totalLimit) {
            this.exceldownloadtrue = true;
          }
          this.generateExcel(this.access, this.exportInfo, response.items);
        }
      }
    })
  }

  getexceldataLeaderBoard() {
    this.apiData['limit'] = this.itemLimit;
    this.apiData['offset'] = this.itemOffset;
    this.apiData['exportAll'] = 0;
    this.leaderBoardApi.getLeaderBoardChartData(this.apiData).subscribe((response) => {
      let responseData = response;
      let total_count = responseData.total;
      this.totalLimit = total_count;
      let exportData = responseData.items;
      this.itemLength += total_count;
      this.itemOffset += this.itemLimit;
      this.progressbarCount = ((this.itemOffset / total_count) * 100).toFixed(0);
      this.progressbarCountWidth = this.progressbarCount + '%';
      if (total_count == 0) {
      }
      else {
        if (this.stopexportapi) {
          if (this.itemOffset >= this.totalLimit) {
            this.exceldownloadtrue = true;
          }
          console.log(exportData);
          this.generateExcel(this.access, this.exportInfo, exportData);
        }
        if (this.itemOffset >= this.totalLimit) {
          this.stopexportapi = false;
        }

      }
    });
  }

  getexceldataUserActivities() {
    this.apiData['limit'] = this.itemLimit;
    this.apiData['offset'] = this.itemOffset;
    this.apiData['exportAll'] = 0;
    this.userActiviesApi.getUserActivitiesChartData(this.apiData).subscribe((response) => {
      let responseData = response;
      let total_count = responseData.total;
      this.totalLimit = total_count;
      let exportData = responseData.data;
      if (this.firstTimeCall === 1) {
        this.firstData = exportData;
      }
      this.itemLength += total_count;
      this.itemOffset += this.itemLimit;
      this.progressbarCount = ((this.itemOffset / total_count) * 100).toFixed(0);
      this.progressbarCountWidth = this.progressbarCount + '%';
      if (total_count == 0) {
      }
      else {
        if (this.stopexportapi) {
          if (this.itemOffset >= this.totalLimit) {
            this.exceldownloadtrue = true;
          }
          this.generateExcel(this.access, this.exportInfo, exportData);
        }
        if (this.itemOffset >= this.totalLimit) {
          this.stopexportapi = false;
        }

      }
    });
  }

  getexceldataThread() {
    this.apiData['limit'] = this.itemLimit;
    this.apiData['offset'] = this.itemOffset;
    this.apiData['exportAll'] = 0;

    this.uploadFlag = this.dashboardApi.apiChartDetail(this.apiData).subscribe((response) => {
      let responseData = response.data;
      let total_count = responseData.total;
      this.totalLimit = total_count;
      let exportThreadData = responseData.chartdetails;

      let threadType = this.exportInfo[1];
      let threadInfo = ['exportThread'];
      console.log(this.isCollabtic);
      let threadList;
      if(this.isCollabtic){
        threadList = this.commonService.getModifiedThreadDataOld(threadInfo, exportThreadData, threadType);
      }
      else{
        threadList = this.commonService.getModifiedThreadData(threadInfo, exportThreadData, threadType);
      }
      this.exportData['threadList'] = threadList;
      this.itemLength += total_count;
      this.itemOffset += this.itemLimit;
      this.progressbarCount = ((this.itemOffset / total_count) * 100).toFixed(0);
      this.progressbarCountWidth = this.progressbarCount + '%';
      if (total_count == 0) {
      }
      else {
        if (this.stopexportapi) {
          if (this.itemOffset >= this.totalLimit) {
            this.exceldownloadtrue = true;;
          }
          this.generateExcel(this.access, this.exportInfo, this.exportData);
        }
        if (this.itemOffset >= this.totalLimit) {
          this.stopexportapi = false;
        }

      }
    }, err => {
      console.log(err)
    });
  }

  exportEmployeeActivity(){
    /*data['startDate'] = this.apiData['filterOptions']['startDate'];
    data['endDate'] = this.apiData['filterOptions']['endDate'];*/
    this.apiData['startDate'] = this.apiData['filterOptions']['startDate'];
    this.apiData['endDate'] = this.apiData['filterOptions']['endDate'];
    this.apiData['dealerCode'] = this.dealerCode;
    this.uploadFlag = this.dashboardApi.apiGetdealerempreport(this.apiData).subscribe((response) => {
      console.log(response);
      if(response.status == 'Success'){
        this.resSuccess = true;
        this.downloadUrl = response.data.url;
        this.downloadUrlFlag = this.downloadUrl != '' ? true : false;
      }
      else{
        this.resSuccessText = response.message;
        this.resSuccess = false;
        this.downloadUrlFlag = true;
      } 
    });
  }

  exportSolrThreadData(){
    let type = this.serviceRecordType;
    let objData = this.serviceRecordObjData;
    console.log(type,objData);
    this.uploadFlag = this.commonService.getSolarThreadExport(type, objData).subscribe(response => {
      console.log(response);
      if(response.status == 'Success'){
        this.resSuccess = true;
        this.downloadUrl = response.data.url;
        this.downloadUrlFlag = this.downloadUrl != '' ? true : false;
      }
      else{
        this.resSuccessText = response.message;
        this.resSuccess = false;
        this.downloadUrlFlag = true;
      } 
    });
  }

  exportSolrThreadDataNew(){
    let type = this.serviceRecordType;
    let objData = this.serviceRecordObjData;
    console.log(type,objData);
    this.uploadFlag = this.commonService.getSolarThreadExportNew(type, objData).subscribe(response => {
      console.log(response);      
      let sessionId = response.export_id;
      let formData = new FormData;
      formData.append('apiKey', this.apiData['apiKey']);
      formData.append('userId',this.apiData['userId']);
      formData.append('domainId',this.apiData['domainId']);
      formData.append('sessionId',sessionId);
      this.uploadFlag = this.commonService.processthreadexport(formData).subscribe((response) => {
        console.log(response);       
      });
      setTimeout(() => {
        this.downloadUrlFlag = true;
        this.resSuccess = true;
      }, 1000);
    });
  }

  exportSummaryData(){
    this.uploadFlag = this.dashboardApi.apiDownloaddashreport(this.apiData).subscribe((response) => {
      console.log(response);
      if(response.status == 'Success'){
        this.resSuccess = true;
        this.downloadUrl = response.data.url;
        this.downloadUrlFlag = this.downloadUrl != '' ? true : false;
      }
      else{
        this.resSuccessText = response.message;
        this.resSuccess = false;
        this.downloadUrlFlag = true;
      } 
    });
  }

   exportTechSupportTickets(){
    this.uploadFlag = this.authenticationService.downloadTechSupportTickets(this.apiData).subscribe((response) => {
      console.log(response);
      if(response.status == 'Success'){
        this.resSuccess = true;
        this.downloadUrl = response.data.url;
        this.downloadUrlFlag = this.downloadUrl != '' ? true : false;
      }
      else{
        this.resSuccessText = response.message;
        this.resSuccess = false;
        this.downloadUrlFlag = true;
      } 
    });
  }

  exportBusinessData(){
    this.uploadFlag = this.dashboardApi.apiDownloadBusinessReport(this.apiData).subscribe((response) => {
      console.log(response);
      if(response.status == 'Success'){
        this.resSuccess = true;
        this.downloadUrl = response.data.url;
        this.downloadUrlFlag = this.downloadUrl != '' ? true : false;
      }
      else{
        this.resSuccessText = response.message;
        this.resSuccess = false;
        this.downloadUrlFlag = true;
      } 
    });
  }
  exportServiceRecords(){
    let type = this.serviceRecordType;
    let objData = this.serviceRecordObjData;
    this.uploadFlag = this.commonService.getSRExportSolr(type, objData).subscribe(response => {
      console.log(response);
      if(response.status == 'Success'){
        this.resSuccess = true;
        this.downloadUrl = response.data.url;
        this.downloadUrlFlag = this.downloadUrl != '' ? true : false;
      }
      else{
        this.resSuccessText = response.message;
        this.resSuccess = false;
        this.downloadUrlFlag = true;
      } 
    });
  }
  exportDealerUsageSolr(){
    let type = this.serviceRecordType;
    let objData = this.serviceRecordObjData;
    this.uploadFlag = this.commonService.solarTVSExportList(type, objData).subscribe(response => {
      console.log(response);
      this.downloadUrl = response.url;
      this.downloadUrlFlag = this.downloadUrl != '' ? true : false;
      this.resSuccess = true;
    });
  }

  exportSummaryWeeklyData(){
    this.uploadFlag = this.dashboardApi.apiDownloaddashreportWeekly(this.apiData).subscribe((response) => {
      console.log(response);
      if(response.status == 'Success'){
        this.resSuccess = true;
        this.downloadUrl = response.data.url;
        this.downloadUrlFlag = this.downloadUrl != '' ? true : false;
      }
      else{
        this.resSuccessText = response.message;
        this.resSuccess = false;
        this.downloadUrlFlag = true;
      } 
    });
  }

  exportJOBSData(){
    this.uploadFlag = this.dashboardApi.apiDownloaddashreportJOBS(this.apiData).subscribe((response) => {
      console.log(response);
      if(response.status == 'Success'){
        this.resSuccess = true;
        this.downloadUrl = response.data.url;
        this.downloadUrlFlag = this.downloadUrl != '' ? true : false;
      }
      else{
        this.resSuccessText = response.message;
        this.resSuccess = false;
        this.downloadUrlFlag = true;
      }      
    });
  }

  exportJOBSType4Data(){
    this.uploadFlag = this.LandingpagewidgetsAPI.getInstallerplannedlist(this.apiData).subscribe((response) => {
      console.log(response);
      if(response.status == 'Success'){
        this.resSuccess = true;
        this.downloadUrl = response.data.url;
        this.downloadUrlFlag = this.downloadUrl != '' ? true : false;
      }
      else{
        this.resSuccessText = response.message;
        this.resSuccess = false;
        this.downloadUrlFlag = true;
      }      
    });
  }
  

  exportGBBGtsReport(){
    const formdata = new FormData()
    formdata.append('apiKey', this.apiData['apiKey']);
    formdata.append('domainId', this.apiData['domainId']);
    formdata.append('countryId', this.apiData['countryId']);
    formdata.append('userId', this.apiData['userId']);
    formdata.append('stateDate', this.apiData['stateDate']);
    formdata.append('endDate', this.apiData['endDate']);
    formdata.append('procedureId', this.apiData['procedureId']);
    this.uploadFlag = this.gtsListingApi.getSessionExcel(formdata).subscribe(
      (response:any) => {
        // console.log(response);
        if(response.status == 'Success'){
        this.resSuccess = true;
        this.downloadUrl = response.data.url;
        this.downloadUrlFlag = this.downloadUrl != '' ? true : false;
      }
      else{
        this.resSuccessText = response.message;
        this.resSuccess = false;
        this.downloadUrlFlag = true;
      } 
      }
    );
  }

  clickDownloadURL(){
    //alert(this.downloadUrl);
    window.open(this.downloadUrl,'_blank');
    this.downloadUrlFlag = false;
    this.updateonExportisDone.emit(1);
  }

  exportDealerActivity() {
    this.apiData['limit'] = this.itemLimit;
    this.apiData['offset'] = this.itemOffset;
    this.apiData['exportAll'] = 0;    
    if(this.branchReport){
      this.apiData['branchReport'] = 1;
    }
    else{
      this.apiData['branchReport'] = 0;
    }
    if(this.dealerUserReport){
      this.apiData['dealerUserReport'] = 1;
      //this.apiData['dealerCode'] = this.dealerCode;
      this.apiData['dealerCodeArr'] = this.dealerCodeArr;
    }
    else{
      this.apiData['dealerUserReport'] = 0;
      this.apiData['dealerCodeArr'] = [];
    }
    console.log(this.apiData);
    this.uploadFlag = this.dashboardApi.apiChartDetail(this.apiData).subscribe((response) => {
      let responseData = response.data;
      let total_count = responseData.total;
      this.totalLimit = total_count;
      let exportData = responseData.chartdetails;
      this.itemLength += total_count;
      this.itemOffset += this.itemLimit;
      this.progressbarCount = ((this.itemOffset / total_count) * 100).toFixed(0);
      this.progressbarCountWidth = this.progressbarCount + '%';
      if (total_count == 0) {
      }
      else {
        /*if (this.stopexportapi) {
          if (this.itemOffset >= this.totalLimit) {
            this.exceldownloadtrue = true;;
          }
          this.generateExcel(this.access, this.title, exportData);
        }
        if (this.itemOffset >= this.totalLimit) {*/
          this.exceldownloadtrue = true;;
          this.generateExcel(this.access, this.title, exportData);

       //}

      }
    });
  }

  exportSummaryJobReport() {
    let type: any = 'list';
    let listing: any = 1;
    let platform: any = 3;
    let typeId = 7;
    let filters = {
      approvalProcess: 1,
      deleteStatusInt: 0,
      domainId: this.apiData['domainId'],
    };
    /*if(this.apiData['domainId']!= 63){
      filters["scanReportInt"] = 1;
    }*/
    let objData = {
      userId: this.apiData['userId'],
      platform,
      type: typeId,
      rows: this.itemLimit,
      start: this.itemOffset,
      listing,
      filters,
    }; 
    let filterDates = {};
    if(this.apiData['startDate'] != '' && this.apiData['startDate'] != undefined && this.apiData['startDate'] != null  && this.apiData['endDate'] != '' && this.apiData['endDate'] != undefined && this.apiData['endDate'] != null){
      filterDates = [{ "field": "createdOnNew", "value1": this.apiData['startDate'], "value2": this.apiData['endDate'], "operator": "<>" }];      
      objData["filterDates"] = filterDates;
    }
       
    let uuIdData = localStorage.getItem('uuIdData');
    if(uuIdData) {
      objData["uuid"] = uuIdData;
    }
    
   /*let filterDates = [];
    if(this.startDate != '' && this.startDate != undefined && this.startDate != null  && this.endDate != '' && this.endDate != undefined && this.endDate != null){
      filterDates = [{ "field": "createdOnNew", "value1": this.startDate, "value2": this.endDate, "operator": "<>" }];
      objData["filterDates"]= filterDates;
    }
    if(this.sortFieldEvent != '' && this.sortFieldEvent != undefined && this.sortFieldEvent != null){
      objData["sortField"] = this.sortFieldEvent; 
      objData["sortOrder"] = this.sortorderEvent == 1 ? 'asc' : 'desc';   
      this.sortFilterapplied = true;
    }
    if(this.searchFilterapplied){       
      objData["filterSearch"] = ((Object.assign({}, this.dataFilterObj)));
    }*/
    this.uploadFlag = this.commonService.getROSolr(type, objData).subscribe(response => {
      let exportData = response.data.items;
      let total_count = response.data.total;
      this.totalLimit = total_count;
      this.itemLength += total_count;
      this.itemOffset += this.itemLimit;
      console.log(this.itemOffset/total_count)
      this.progressbarCount = ((this.itemOffset / total_count) * 100).toFixed(0);
      this.progressbarCountWidth = this.progressbarCount + '%';
      if (total_count == 0) {
      }
      else {
        if (this.stopexportapi) {
          if (this.itemOffset >= this.totalLimit) {
            this.exceldownloadtrue = true;;
          }
          this.generateExcel(this.access, this.exportInfo, exportData);
        }
        if (this.itemOffset >= this.totalLimit) {
          this.stopexportapi = false;
        }
      }
    });
  }

  exportSalesReport(){
    this.apiData['limit'] = this.itemLimit;
    this.apiData['offset'] = this.itemOffset;
    let formData = new FormData;
    formData.append('apiKey', this.apiData['apiKey']);
    formData.append('userId',this.apiData['userId']);
    formData.append('domainId',this.apiData['domainId']);
    formData.append('offset', this.apiData['offset']);
    formData.append('limit', this.apiData['limit']);
    formData.append('rowId', this.apiData['rowId']);
    formData.append('timezone', this.apiData['timezone']);
    formData.append('startDate', this.apiData['startDate']);
    formData.append('endDate', this.apiData['endDate']);    

    if(this.apiData['businessId'] != ''){
      formData.append('businessId',this.apiData['businessId']);
    }
    if(this.apiData['marketId'] != ''){
      formData.append('marketId',this.apiData['marketId']);
    }
    if(this.apiData['salesRepId'] != ''){
      formData.append('salesRepId',this.apiData['salesRepId']);
    }
    this.uploadFlag = this.authenticationService.salesdashboardAPI(formData).subscribe((response) => {
console.log(response);
      let exportData = response.data.items;
      exportData.forEach(eitem => {
        this.roList.push(eitem);  
      });
      let total_count = response.data.total;
      this.totalLimit = total_count;
      this.itemLength += total_count;
      this.itemOffset += this.itemLimit;
      console.log(this.itemOffset/total_count)
      this.progressbarCount = ((this.itemOffset / total_count) * 100).toFixed(0);
      this.progressbarCountWidth = this.progressbarCount + '%';
      if (total_count > 0) {
       if (this.stopexportapi) {
          if (this.itemOffset >= this.totalLimit) {
            this.exceldownloadtrue = true;;
          }
          this.generateExcel(this.access, this.exportInfo, exportData);
        }
        if (this.itemOffset >= this.totalLimit) {
          this.stopexportapi = false;
        }
      }
    });
  }
  exportRoReportFilter(){
    let type = this.serviceRecordType;
    let objData = this.serviceRecordObjData;
    objData["rows"] = this.itemLimit; 
    objData["start"] = this.itemOffset;
    //console.log(type, objData);
    //return false;
    this.uploadFlag = this.commonService.getROSolr(type, objData).subscribe(response => {
      let exportData = response.items;
      exportData.forEach(eitem => {
        this.roList.push(eitem);  
      });
      let total_count = response.total;
      this.totalLimit = total_count;
      this.itemLength += total_count;
      this.itemOffset += this.itemLimit;
      console.log(this.itemOffset/total_count)
      this.progressbarCount = ((this.itemOffset / total_count) * 100).toFixed(0);
      this.progressbarCountWidth = this.progressbarCount + '%';
      if (total_count > 0) {
       if (this.stopexportapi) {
          if (this.itemOffset >= this.totalLimit) {
            this.exceldownloadtrue = true;;
          }
          this.generateExcel(this.access, this.exportInfo, exportData);
        }
        if (this.itemOffset >= this.totalLimit) {
          this.stopexportapi = false;
        }
      }
    });
  }

  exportRoReport() {
    let type: any = 'list';
    let listing: any = this.apiData['listing'];
    let platform: any = this.apiData['platForm'];
    let typeId = 7;
    let filters = this.apiData['filters'];
    let objData = {
      userId: this.apiData['userId'],
      platform,
      type: typeId,
      rows: this.itemLimit,
      start: this.itemOffset,
      listing,
      filters,
    }; 
     if(this.apiData["sortField"] != '' && this.apiData["sortField"] != undefined) {
      objData["sortField"] = this.apiData["sortField"]; 
      objData["sortOrder"] = this.apiData["sortOrder"];
    }
    if(this.apiData["filterSearch"] != '' && this.apiData["filterSearch"] != undefined) {
      objData["filterSearch"] = this.apiData["filterSearch"];
    }
    if(this.apiData["filterDates"] != '' && this.apiData["filterDates"] != undefined) {
      objData["filterDates"] = this.apiData["filterDates"];
    }   
    let uuIdData = localStorage.getItem('uuIdData');
    if(uuIdData) {
      objData["uuid"] = uuIdData;
    }
    
    this.uploadFlag = this.commonService.getROSolr(type, objData).subscribe(response => {
      let exportData = response.items;
      exportData.forEach(eitem => {
        this.roList.push(eitem);  
      });
      let total_count = response.total;
      this.totalLimit = total_count;
      this.itemLength += total_count;
      this.itemOffset += this.itemLimit;
      console.log(this.itemOffset/total_count)
      this.progressbarCount = ((this.itemOffset / total_count) * 100).toFixed(0);
      this.progressbarCountWidth = this.progressbarCount + '%';
      if (total_count > 0) {
       if (this.stopexportapi) {
          if (this.itemOffset >= this.totalLimit) {
            this.exceldownloadtrue = true;;
          }
          this.generateExcel(this.access, this.exportInfo, exportData);
        }
        if (this.itemOffset >= this.totalLimit) {
          this.stopexportapi = false;
        }
      }
    });
  }

  generateExcel(access, title, exportData, type1='', type2='',type3='',type4='') {
    switch (access) {
      case 'gtsDealer':
        this.exportDealerUsage(title, exportData);
        break;
      case 'summary-job-report':
        this.exportJobReport(title, exportData);
        break;
      case 'ro-report':
          this.exportRoReportData(title, exportData);
          break; 
      case 'ro-report-filter':
        this.exportRoReportFilterData(title, exportData);
        break; 
      case 'sales-report':
        this.exportSalesReportData(title, exportData);
        break;  
      case 'dealerUsage':
      case 'serviceProbing':
        this.exportDealers(title, exportData);
        break;
      case 'threads':
        if (this.isCollabtic) {
          this.exportThreadReportsOld(title, exportData);
        }
        else{
          this.exportThreadReports(title, exportData);
        }        
        break;
      case 'leaderboard':
        this.exportLeaderBoardReport(title, exportData);
        break;
      case 'user-activities':
        this.firstTimeCall += this.firstTimeCall;
        this.exportUserActivitiesReport(title, exportData);
        break;
      case 'gts':
        this.exportGTSReport(access, title, exportData);
        break;
      case 'user-dashboard':
        this.exportUserDashboardReport(access, title, exportData,type1, type2, type3, type4);
        break;
      case 'dtc':
        this.exportDTCReport(access, title, exportData);
        break;
      case 'diagnostic':
        this.exportDiagnosticReport(access, title, exportData);
        break;
      case 'adas':
        this.exportAdasReport(access, title, exportData);
        break;
      case 'customer-template':
        this.exportCustomersReport(this.exportInfo);
        break;
    }
  }

  exportLeaderBoardReport(title, exportData) {
    let apiData = exportData;
    let headers = ['Position', 'Username', 'Email Address', 'Thread Count', 'Reply Count', 'Badge Point'];
    apiData.forEach(data => {
      this.sNo = this.sNo + 1;
      let leaderInfo = [this.sNo, data.username, data.email, data.threadCount, data.replyCount, data.socialPoint];
      this.leaderInfo.push(leaderInfo)
    });

    let workbook = new Workbook();
    let startDateExcel = '';
    if (this.apiData.hasOwnProperty('startDate') && this.apiData.hasOwnProperty('endDate')) {
      startDateExcel = ' for ' + moment(this.apiData.startDate).format('MMM DD, YYYY') + ' - ' +
        moment(this.apiData.endDate).format('MMM DD, YYYY');
    }
    let worksheet = workbook.addWorksheet(title[0]);

    let titleRow = worksheet.addRow([title[0] + ' ' + startDateExcel]);
    titleRow.font = { name: 'Comic Sans MS', family: 4, size: 16, bold: true }
    worksheet.addRow([]);

    let headerRow = worksheet.addRow(headers);

    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'e8e3e3' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' } }
    });

    this.leaderInfo.forEach(l => {
      let row = worksheet.addRow(l);
      let qty = row.getCell(6);
      let color = 'FF99FF';
      if (+qty.value < 500) {
        color = 'FF9999'
      }
      qty.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: color }
      }
    });

    worksheet.getColumn(1).width = 30;
    worksheet.getColumn(2).width = 30;
    worksheet.getColumn(3).width = 30;
    worksheet.getColumn(4).width = 30;
    worksheet.getColumn(5).width = 30;
    worksheet.getColumn(6).width = 30;
    worksheet.addRow([]);

    if (this.exceldownloadtrue) {
      this.progressbarCount = '100';
      this.progressbarCountWidth = this.progressbarCount + '%';
      this.downloadtextflag = 'Export complete.';

      setTimeout(() => {
        //Generate Excel File with given name
        workbook.xlsx.writeBuffer().then((data) => {
          let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          fs.saveAs(blob, 'Leaderboard.xlsx');
        });
        this.exceldownloadtrue = false;
        this.stopexportapi = true;
        this.itemOffset = 0;
        this.threadLists = [];
        this.progressbarCount = '0';
        this.progressbarCountWidth = this.progressbarCount + '%';
        this.downloadtextflag = 'Exporting data to Excel..';
        this.updateonExportisDone.emit(1);
      }, 3000);
    } else {
      this.getexceldataLeaderBoard();
    }
  }

  exportUserActivitiesReport(title, exportData) {
    let apiData = exportData;
    let headers = ['Username'];
    this.firstData[0].metrics.forEach((metric: any) => {
      headers.push(metric.title);
    });
    headers.push('Total Count');
    if (apiData && apiData.length) {
      apiData.forEach((data: any) => {
        let valueArray: any = [];
        this.sNo = this.sNo + 1;
        valueArray.push(data.userName);
        for (let metric of data.metrics) {
          valueArray.push(parseInt(metric.count));
        }
        valueArray.push(data.totalCount);
        this.userActivitiesInfo.push(valueArray)
      });
    }

    let workbook = new Workbook();
    let startDateExcel = '';
    if (this.apiData.hasOwnProperty('startDate') && this.apiData.hasOwnProperty('endDate')) {
      startDateExcel = ' for ' + moment(this.apiData.startDate).format('MMM DD, YYYY') + ' - ' +
        moment(this.apiData.endDate).format('MMM DD, YYYY');
    }
    let worksheet = workbook.addWorksheet(title[0]);

    let titleRow = worksheet.addRow([title[0] + ' ' + startDateExcel]);
    titleRow.font = { name: 'Calibri', family: 4, size: 16, bold: true }
    worksheet.addRow([]);

    let headerRow = worksheet.addRow(headers);

    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'e8e3e3' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' } }
    });

    this.userActivitiesInfo.forEach(l => {
      worksheet.addRow(l);
    });

    headers.forEach((header: any, index: number) => {
      worksheet.getColumn(index + 1).width = 30;
      worksheet.addRow([]);
    })

    if (this.exceldownloadtrue) {
      this.progressbarCount = '100';
      this.progressbarCountWidth = this.progressbarCount + '%';
      this.downloadtextflag = 'Export complete.';
      this.firstTimeCall = 1;
      setTimeout(() => {
        //Generate Excel File with given name
        workbook.xlsx.writeBuffer().then((data) => {
          let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          fs.saveAs(blob, 'Useractivities.xlsx');
        });
        this.exceldownloadtrue = false;
        this.stopexportapi = true;
        this.itemOffset = 0;
        this.threadLists = [];
        this.progressbarCount = '0';
        this.progressbarCountWidth = this.progressbarCount + '%';
        this.downloadtextflag = 'Exporting data to Excel..';
        this.updateonExportisDone.emit(1);
      }, 3000);
    } else {
      this.getexceldataUserActivities();
    }
  }

  exportDealers(title, exportData) {    
    let apiData = exportData;
    let header:any = '';
    if(this.dealerUserReport){
      header = ['Dealer Name', 'Dealer Code','Branch Name', 'Branch ID', 'User Name', 'Employee Id', 'Zone', 'Area', 'TM Name', 'ASM Name', 'Territory'];
    }
    else if(this.branchReport){
      header = ['Dealer Name', 'Dealer Code','Branch Name', 'Branch ID', 'Zone', 'Area', 'TM Name', 'ASM Name', 'Territory'];
    }
    else{      
      header = ['Dealer Name', 'Dealer Code', 'Zone', 'Area', 'TM Name', 'ASM Name', 'Territory'];
    }
    let monthInfo = apiData[0].interdays;
    for(var m of monthInfo) {
      header.push(m.day)
    }
    header.push('Total Time(Minutes)');
    header.push('Usage category');
   // let dealerData = [];
    for(var info in apiData) {
      let days = [];
      let dayInfo = apiData[info].interdays;
      let utype = parseInt(apiData[info].userType);
      let name = (utype == 2) ? apiData[info].dealerName : apiData[info].userName;
      let id = (utype == 2) ? apiData[info].dealerCode : apiData[info].userId;
      let dealerInfo:any=[];
      if(this.dealerUserReport){

        let dealerCode = apiData[info].dealerCode ? apiData[info].dealerCode : '';
        let dealerName = apiData[info].dealerName ? apiData[info].dealerName : '';
        
        let bid = apiData[info].branchId ? apiData[info].branchId : '';
        let bname = apiData[info].branchName ? apiData[info].branchName : '';

        let userId = apiData[info].userId ? apiData[info].userId : '';
        let userName = apiData[info].userName ? apiData[info].userName : '';

        dealerInfo = [dealerName, dealerCode, bname, bid, userName, userId, apiData[info].zone, apiData[info].userarea,apiData[info].tmName, apiData[info].asmName,apiData[info].territory];      
      }
      else if(this.branchReport){
        let bid = apiData[info].branchId ? apiData[info].branchId : '';
        let bname = apiData[info].branchName ? apiData[info].branchName : '';
        dealerInfo = [name, id, bname, bid, apiData[info].zone, apiData[info].userarea,apiData[info].tmName, apiData[info].asmName,apiData[info].territory];      
      }
      else{
        dealerInfo = [name, id, apiData[info].zone, apiData[info].userarea,apiData[info].tmName, apiData[info].asmName,apiData[info].territory];      
      }

      for(var d of dayInfo) {
        dealerInfo.push(d.totaltime);
      }
      dealerInfo.push(apiData[info].totaltime);
      dealerInfo.push(apiData[info].totalFlag);
      
      this.dealerData.push(dealerInfo);
    }
   
    setTimeout(() => {
      
      //Create workbook and worksheet
      let workbook = new Workbook();
      let worksheet = workbook.addWorksheet(title);

      //Add Row and formatting
      let titleText = this.dealerUserReport ? title+", Dealer Code: "+this.dealerCodeArr : title;
      let titleRow = worksheet.addRow([titleText]);
      titleRow.font = { name: 'Comic Sans MS', family: 4, size: 16, bold: true }
      worksheet.addRow([]);
      //let subTitleRow = worksheet.addRow(['Date : ' + this.datePipe.transform(new Date(), 'medium')]);

      //Blank Row 
      worksheet.addRow([]);
      
      // Add Header Row
      let headerRow = worksheet.addRow(header);

      // Cell Style : Fill and Border
      headerRow.eachCell((cell, number) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          //fgColor: { argb: 'FFFFFF00' },
          fgColor: { argb: 'e8e3e3' },
          
          bgColor: { argb: 'FF0000FF' }
        }
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      });

      // Add Data and Conditional Formatting

      header.forEach((item, index) => {
        let width = (index > 10 && index != header.length - 2) ? 15 : (index == 0 || index == 2 || index == 4 ) ? 35 : 25;
        worksheet.getColumn(index+1).width = width;
      })
  
      this.dealerData.forEach(d => {
        let row = worksheet.addRow(d);
        let totalColumn = header.length - 1;
        let qty = row.getCell(totalColumn);
          let color = 'FF99FF';
          if (+qty.value < 500) {
            color = 'FF9999'
          }
          qty.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: color }
        }     

      });

/*
      worksheet.getColumn(1).width = 30;
      worksheet.getColumn(2).width = 30;
      worksheet.getColumn(3).width = 30;
      worksheet.getColumn(4).width = 30;
      worksheet.getColumn(5).width = 30;
      worksheet.getColumn(6).width = 30;
      worksheet.getColumn(7).width = 30; */    
      worksheet.addRow([]);

      if(this.exceldownloadtrue)
      {
        this.progressbarCount='100';
        this.progressbarCountWidth=this.progressbarCount+'%';
        this.downloadtextflag='Export complete.';
        
        setTimeout(() => {
      //Generate Excel File with given name
      workbook.xlsx.writeBuffer().then((data) => {
        let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });   
        title = title.replaceAll(" ","_")     
        let fName = this.dealerUserReport ? title+"_"+this.dealerCodeArr+"_"+this.currDateTime : title+"_"+this.currDateTime ;
        fs.saveAs(blob, fName+'.xlsx');
      });
      this.exceldownloadtrue=false; 
      this.stopexportapi=true;
      this.itemOffset=0;
      this.threadLists=[];
      this.progressbarCount='0';
      this.progressbarCountWidth=this.progressbarCount+'%';
      this.downloadtextflag='Exporting data to Excel..';
      this.updateonExportisDone.emit(1);
    },3000);
    }
    else
    {
     // this.exportDealerActivity();
    } 
    
      //Generate Excel File with given name
      
    }, 2000);
  }

  exportDealersOld(title, exportData) {
    let apiData = exportData;
    let header = ['Dealer Name', 'ID', 'Zone', 'Area', 'Territory'];
    let monthInfo = apiData[0].interdays;
    for (let m of monthInfo) {
      header.push(m.day)
    }
    header.push('Total Time');
    // let dealerData = [];
    for (let info in apiData) {
      let days = [];
      let dayInfo = apiData[info].interdays;
      let utype = parseInt(apiData[info].userType);
      let name = (utype == 2) ? apiData[info].dealerName : apiData[info].userName;
      let id = (utype == 2) ? apiData[info].dealerCode : apiData[info].userId;
      let dealerInfo = [name, id, apiData[info].zone, apiData[info].userarea, apiData[info].territory];
      for (let d of dayInfo) {
        dealerInfo.push(d.totaltime);
      }
      dealerInfo.push(apiData[info].totaltime);
      this.dealerData.push(dealerInfo);
    }


    //Create workbook and worksheet
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet(title);

    //Add Row and formatting
    let titleRow = worksheet.addRow([title]);
    titleRow.font = { name: 'Comic Sans MS', family: 4, size: 16, bold: true }
    worksheet.addRow([]);
    //let subTitleRow = worksheet.addRow(['Date : ' + this.datePipe.transform(new Date(), 'medium')]);

    //Blank Row
    worksheet.addRow([]);

    // Add Header Row
    let headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        //fgColor: { argb: 'FFFFFF00' },
        fgColor: { argb: 'e8e3e3' },

        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    });

    // Add Data and Conditional Formatting
    this.dealerData.forEach(d => {
      let row = worksheet.addRow(d);
      let qty = row.getCell(5);
      let color = 'FF99FF';
      if (+qty.value < 500) {
        color = 'FF9999'
      }
      qty.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: color }
      }
    });

    worksheet.getColumn(1).width = 30;
    worksheet.getColumn(2).width = 30;
    worksheet.getColumn(3).width = 30;
    worksheet.getColumn(4).width = 30;
    worksheet.getColumn(5).width = 30;
    worksheet.addRow([]);

    if (this.exceldownloadtrue) {
      this.progressbarCount = '100';
      this.progressbarCountWidth = this.progressbarCount + '%';
      this.downloadtextflag = 'Export complete.';

      setTimeout(() => {
        //Generate Excel File with given name
        workbook.xlsx.writeBuffer().then((data) => {
          let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          fs.saveAs(blob, 'Dealer_Usage.xlsx');
        });
        this.exceldownloadtrue = false;
        this.stopexportapi = true;
        this.itemOffset = 0;
        this.threadLists = [];
        this.progressbarCount = '0';
        this.progressbarCountWidth = this.progressbarCount + '%';
        this.downloadtextflag = 'Exporting data to Excel..';
        this.updateonExportisDone.emit(1);
      }, 3000);
    }
    else {
      this.exportDealerActivity();
    }

    //Generate Excel File with given name


  }

  exportDealerUsage(title, exportData) {
    let apiData = exportData;
    //let header = ['Dealer Name', 'ID', 'Zone', 'Area', 'TM Name', 'ASM Name', 'Territory', 'Model', 'TITLE', 'Total GTS viewed', 'Start date/time', 'Username', 'Designation', 'Duration of GTS Mins', 'GTS Viewed time in Mins', 'GTS Viewed %', 'GTS Release Date/Time', 'Usage Category' ];
    let header = ['Dealer Name', 'ID', 'Branch ID', 'Branch Name', 'Zone', 'Area', 'TM Name', 'ASM Name', 'Territory', 'Model', 'Frame No', 'Trouble Code', 'TITLE', 'Kms', 'Start Date', 'Dealer Employee No', 'Username', 'Designation', 'GTS Viewed time in Mins', 'GTS Release Date/Time', 'Feedback' ];
 
    for(var info in apiData) {
      let startDate = moment(apiData[info].gtsSessionCreateTime).format('DD/MM/YYYY').toString();
      let releaseDate = moment(apiData[info].gtsReleaseDate).format('MMM DD, YYYY h:mm A').toString();
      //let dealerInfo = [apiData[info].dealerName, apiData[info].dealerCode, apiData[info].zone, apiData[info].area,apiData[info].tmName, apiData[info].asmName, apiData[info].territory, apiData[info].vehicleInfo, apiData[info].gtsTitle, '', startDate, apiData[info].userName, apiData[info].designation, apiData[info].totalDurationTimeTaken, apiData[info].totalViewedTimeTaken, apiData[info].gtsViewedPercenTage, releaseDate, apiData[info].usageCategory];      
      let dealerInfo = [apiData[info].dealerName, apiData[info].dealerCode,apiData[info].branchId,apiData[info].branchName, apiData[info].zone, apiData[info].area,apiData[info].tmName, apiData[info].asmName, apiData[info].territory, apiData[info].vehicleInfo, apiData[info].frameNo, apiData[info].troubleCode, apiData[info].gtsTitle, apiData[info].odometerNo, startDate, apiData[info].employeeId, apiData[info].userName, apiData[info].designation, apiData[info].totalDurationTimeTaken, releaseDate, apiData[info].gtsFeedback,];      
  
      this.dealerData.push(dealerInfo);
    }

    
      //Create workbook and worksheet
      let workbook = new Workbook();
      let sheetName = 'GTS Dealer Employee Usage';
      let worksheet = workbook.addWorksheet(sheetName);
      //let worksheet2 = workbook.addWorksheet('Sheet 2');

           //Add Row and formatting
      let titleRow = worksheet.addRow(["GTS Usage Dealer Employee Report"]);
      titleRow.font = { name: 'Calibri', family: 4, size: 13, bold: true, color: {argb: '0660C7'} }
           
     
      let sdate = localStorage.getItem('gtsDealerStartDate');
      let edate = localStorage.getItem('gtsDealerEndDate');
      sdate = moment(sdate).format('MMM DD, YYYY').toString();
      edate = moment(edate).format('MMM DD, YYYY').toString();
      let subTitleRow = "Date Range : " +sdate+ ' to ' +edate;

      worksheet.addRow([]);
      //Add Row and formatting
      let subTitleRow1 = worksheet.addRow([subTitleRow]);
      subTitleRow1.font = { name: 'Calibri', family: 4, size: 12, bold: true, color: {argb: '0660C7'}}
      
      //Blank Row 
      worksheet.addRow([]);
      
      // Add Header Row
      let headerRow = worksheet.addRow(header);

      // Cell Style : Fill and Border
      headerRow.eachCell((cell, number) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          //fgColor: { argb: 'FFFFFF00' },
          fgColor: { argb: 'e8e3e3' },
          
          bgColor: { argb: 'FF0000FF' }
        }
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      });

      // Add Data and Conditional Formatting
      this.dealerData.forEach(d => {
        let row = worksheet.addRow(d);
        let qty = row.getCell(7);
        let color = 'FF99FF';
        if (+qty.value < 500) {
          color = 'FF9999'
        }
        qty.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: color }
        }
      });

      worksheet.getColumn(1).width = 30;
      worksheet.getColumn(2).width = 30;
      worksheet.getColumn(3).width = 30;
      worksheet.getColumn(4).width = 30;
      worksheet.getColumn(5).width = 30;
      worksheet.getColumn(6).width = 30;
      worksheet.getColumn(7).width = 30;     
      worksheet.getColumn(8).width = 30;     
      worksheet.getColumn(9).width = 30;     
      worksheet.getColumn(10).width = 30;     
      worksheet.getColumn(11).width = 30;     
      worksheet.getColumn(12).width = 30;     
      worksheet.getColumn(13).width = 30;     
      worksheet.getColumn(14).width = 30;     
      worksheet.getColumn(15).width = 30;     
      worksheet.getColumn(16).width = 30;     
      worksheet.getColumn(17).width = 30;     
      worksheet.getColumn(18).width = 30;     
      worksheet.getColumn(19).width = 30;     
      worksheet.getColumn(20).width = 30;     
      worksheet.getColumn(21).width = 30;     
      worksheet.getColumn(22).width = 30;     
      worksheet.getColumn(23).width = 30;     
      worksheet.getColumn(24).width = 30;     
      worksheet.getColumn(25).width = 30;     
      worksheet.addRow([]);

      if(this.exceldownloadtrue)
      {
        this.progressbarCount='100';
        this.progressbarCountWidth=this.progressbarCount+'%';
        this.downloadtextflag='Export complete.';
        
        setTimeout(() => {
      //Generate Excel File with given name
      workbook.xlsx.writeBuffer().then((data) => {
        let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        fs.saveAs(blob, 'GTS_Dealer_Usage'+this.currDateTime+'.xlsx');
      });
      this.exceldownloadtrue=false; 
      this.stopexportapi=true;
      this.itemOffset=0;
      this.threadLists=[];
      this.progressbarCount='0';
      this.progressbarCountWidth=this.progressbarCount+'%';
      this.downloadtextflag='Exporting data to Excel..';
      this.updateonExportisDone.emit(1);
    },3000);
    }
    else
    {
      this.exportDealerActivity();
    } 
    
      //Generate Excel File with given name
      
   
  }
  exportJobReport(title, exportData) {
    let apiData = exportData;
    let header = ['Customer Name', 'City', 'State', 'Market', 'Sales Rep', 'Scan Date', 'Estimated Date', 'Estimated Value', 'Approval Date', 'Completion Date', 'Cycle Time' ];
    let dealerInfo:any=[];
    apiData.forEach(item => {  
      let roCreatedDate:any = '', roCompletedDate:any = '';
      let roBusinessNameStr = '-', roBusinessCityStr = '-', roBusinessStateStr = '-', market = '-', marketNameStr = '',  salesRep = '-',  salesRepNameStr='-', createdOnStr: any = '-', scanDate: any = '-', estimateDate:any = '-', estimateValue:any = '-', approvalDate:any = '-', completionDate:any = '-', cycleTime = '-';
      let businessInfoJsonArr = (item.businessInfoJsonArr && item.businessInfoJsonArr != undefined) ? (item.businessInfoJsonArr) : '';
      if(businessInfoJsonArr != '') {
        let business = businessInfoJsonArr[0];
        if(business){
          roBusinessNameStr = business.name != '' ? business.name : '-' ;
          roBusinessCityStr =  business.city != '' ? business.city : '-' ;
          roBusinessStateStr =  business.state != '' ? business.state : '-' ;
        }        
      }
      let marketId = item.marketIdInt;
      marketNameStr = (marketId > 0 && item.marketNameStr != null && item.marketNameStr != undefined && item.marketNameStr != '') ? item.marketNameStr : market;
      let salesRepId = item.salesRepIdInt;
      salesRepNameStr = (salesRepId > 0 && item.salesRepNameStr != null && item.salesRepNameStr != undefined && item.salesRepNameStr != '') ? item.salesRepNameStr : salesRep;
      
      if(item.createdOnStr && (item.createdOnStr != null || item.createdOnStr != undefined || item.createdOnStr != '' || item.createdOnStr !='0000-00-00 00:00:00')){ 
        let createdOn = moment.utc(item.createdOnStr).toDate();
        createdOnStr = moment(createdOn).local().format('MMM DD, YYYY');
        roCreatedDate = moment(createdOn).local().format('MMM DD, YYYY h:mm A');
      }

      if(item.approvedDateStr && (item.approvedDateStr != null || item.approvedDateStr != undefined || item.approvedDateStr != '' || item.approvedDateStr !='0000-00-00 00:00:00')){ 
        let approvedOn = moment.utc(item.approvedDateStr).toDate();
        approvalDate = moment(approvedOn).local().format('MMM DD, YYYY');
      }

      if(item.completedDateStr && (item.completedDateStr != null || item.completedDateStr != undefined || item.completedDateStr != '' || item.completedDateStr !='0000-00-00 00:00:00')){
        let completedOn = moment.utc(item.completedDateStr).toDate();
        completionDate = moment(completedOn).local().format('MMM DD, YYYY');
        roCompletedDate = moment(completedOn).local().format('MMM DD, YYYY h:mm A');
      }

      if(item.estimateInfoDataJsonArr && (item.estimateInfoDataJsonArr != null || item.estimateInfoDataJsonArr != undefined || item.estimateInfoDataJsonArr != '')) {
        let estimateDataInfo = item.estimateInfoDataJsonArr[0];
        let estimateCreatedOn = estimateDataInfo.createdOn;
        let estDate = moment.utc(estimateCreatedOn).toDate();
        estimateDate = moment(estDate).local().format('MMM DD, YYYY');
      }

      if(item.estimationDataJsonArr && (item.estimationDataJsonArr != null || item.estimationDataJsonArr != undefined || item.estimationDataJsonArr != '')) {
        let estimateData = item.estimationDataJsonArr[0];
        let estimateTotal = estimateData.estimationTotal;
        estimateValue = (estimateTotal != '') ? `$${estimateTotal}` : '-';
        estimateDate = (estimateTotal != '') ? estimateDate : '-';
      }

      if(createdOnStr != '' && completionDate != '') {
        let startDate = new Date(roCreatedDate).getTime();
        let endDate = new Date(roCompletedDate).getTime();
        let differenceInMs: number = endDate - startDate;
        let millisecondsInDay: number = 1000 * 60 * 60 * 24;
        let differenceInDays: number = Math.ceil(differenceInMs / millisecondsInDay);
        let millisecondsInHours: number = 1000 * 60 * 60;
        let differenceInHours: number = Math.floor(differenceInMs / millisecondsInHours);
        let millisecondsInMins: number = 1000 * 60;
        let differenceInMins: number = Math.floor(differenceInMs / millisecondsInMins);
        if(differenceInDays > 0) {
          let dayText = (differenceInDays > 1) ? 'Days' : 'Day';
          cycleTime = `${differenceInDays} ${dayText}`;
        } else {
          cycleTime = '1 Day';
        }
      }
      
      dealerInfo = [roBusinessNameStr, roBusinessCityStr, roBusinessStateStr, marketNameStr, salesRepNameStr, createdOnStr, estimateDate, estimateValue, approvalDate, completionDate, cycleTime];
      this.dealerData.push(dealerInfo);      
    });

    
      
      //Create workbook and worksheet
      let workbook = new Workbook();
      let sheetName = 'Job Report';
      let worksheet = workbook.addWorksheet(sheetName);
      //let worksheet2 = workbook.addWorksheet('Sheet 2');

           //Add Row and formatting
      let titleRow = worksheet.addRow(["Job Report"]);
      titleRow.font = { name: 'Calibri', family: 4, size: 16, bold: true }           
     
      let sdate = this.apiData['startDate'];
      let edate = this.apiData['endDate'];

      if(sdate != '' && edate != ''){
      sdate = moment(sdate).format('MMM DD, YYYY').toString();
      edate = moment(edate).format('MMM DD, YYYY').toString();
      let subTitleRow = "Date Range : " +sdate+ ' to ' +edate;

      //worksheet.addRow([]);
      //Add Row and formatting
      let subTitleRow1 = worksheet.addRow([subTitleRow]);
      subTitleRow1.font = { name: 'Calibri', family: 4, size: 12, bold: true}
      }
      //Blank Row 
      worksheet.addRow([]);
      
      // Add Header Row
      let headerRow = worksheet.addRow(header);

      // Cell Style : Fill and Border
      headerRow.eachCell((cell, number) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          //fgColor: { argb: 'FFFFFF00' },
          fgColor: { argb: 'e8e3e3' },
          
          bgColor: { argb: 'FF0000FF' }
        }
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      });

      

      // Add Data and Conditional Formatting
      this.dealerData.forEach(d => {
        worksheet.addRow(d);
        /*let row = worksheet.addRow(d);
        let qty = row.getCell(7);
        let color = 'FF99FF';
        if (+qty.value < 500) {
          color = 'FF9999'
        }
        qty.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: color }
        }*/
      });

      worksheet.getColumn(1).width = 35;
      worksheet.getColumn(2).width = 20;
      worksheet.getColumn(3).width = 20;
      worksheet.getColumn(4).width = 20;
      worksheet.getColumn(5).width = 20;
      worksheet.getColumn(6).width = 20;
      worksheet.getColumn(7).width = 20;     
      worksheet.getColumn(8).width = 20;     
      worksheet.getColumn(9).width = 20;     
      worksheet.getColumn(10).width = 20;     
      worksheet.getColumn(11).width = 20;          
      worksheet.addRow([]);

      if(this.exceldownloadtrue)
      {
        this.progressbarCount='100';
        this.progressbarCountWidth=this.progressbarCount+'%';
        this.downloadtextflag='Export complete.';
        
        setTimeout(() => {
      //Generate Excel File with given name
      workbook.xlsx.writeBuffer().then((data) => {
        let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        fs.saveAs(blob, 'job_report_'+this.currDateTime+'.xlsx');
      });
      this.exceldownloadtrue=false; 
      this.stopexportapi=true;
      this.itemOffset=0;
      this.dealerData=[];
      this.progressbarCount='0';
      this.progressbarCountWidth=this.progressbarCount+'%';
      this.downloadtextflag='Exporting data to Excel..';
      this.updateonExportisDone.emit(1);
    },3000);
    }
    else
    {
      this.exportSummaryJobReport();
    } 
    
      //Generate Excel File with given name
      
   
  }

  exportSalesReportData(title, exportData) {
    console.log(exportData)
    let apiData = exportData;
    let shortTitle = this.apiData['shortTitle'];
    let roIdCol = `${shortTitle} ID#`;
    let roDateCol = `${shortTitle} Date`;
    let shopRoCol = `Shop ${shortTitle}`;
    let header:any = [];
    
    header = ['ID#', 'Business Name', 'City', 'State', 'Market', 'SalesRep', 'Scans', 'Estimate Sent', 'Approved', 'Complete', 'Canceled'];
        
    let dealerInfo:any=[];
    apiData.forEach(item => {  

      let shopId = parseInt(item.shopId);
      let shopName = item.shopName;
      let city = item.city;
      let state = item.state;
      let marketName = item.marketNames && item.marketNames.length>0 ? item.marketNames[0] : '-';
      let salesRep = item.salesPersonInfo && item.salesPersonInfo.length>0 ? item.salesPersonInfo[0].name : '-';
      let salesRepCount = item.salesPersonInfo && item.salesPersonInfo.length>1 ? item.salesPersonInfo.length - 1 : 0;
      let n = 0;

      let salesRepNew=[];
      if(item.salesPersonInfo && item.salesPersonInfo.length>1){
        item.salesPersonInfo.forEach(rep => {
          if(n==0){
            salesRepNew.push(rep.name);
          }
          else{
            salesRepNew.push(" "+rep.name);
          }  
          n++;    
        });
      }  
      if(item.salesPersonInfo && item.salesPersonInfo.length==1){
        salesRepNew=salesRep;
      }  
           
      let salesRepStr = item.salesPersonInfo && item.salesPersonInfo.length>0 ? salesRepNew.toString() : '-';

      console.log(salesRepStr);
      let scans = item.scanCount;
      let estimateData = item.itemsEstimate ? true : false;
      let estimateDataVal = '-';
      if(estimateData){
        let count = this.commonService.numberWithCommasThreeDigit(Math.abs(item.itemsEstimate['count']).toFixed(2));
        estimateDataVal = Math.round(item.itemsEstimate['percentage'])+"%, $"+count;
      }
      let approvedData = item.itemsApproved ? true : false;
      let approvedDataVal = '-';
      if(approvedData){
        let count = this.commonService.numberWithCommasThreeDigit(Math.abs(item.itemsApproved['count']).toFixed(2));
        approvedDataVal = Math.round(item.itemsApproved['percentage'])+"%, $"+count;
      }
      let completeData = item.itemsCompleted ? true : false;
      let completeDataVal = '-';
      if(completeData){
        let count = this.commonService.numberWithCommasThreeDigit(Math.abs(item.itemsCompleted['count']).toFixed(2));
        completeDataVal =  Math.round(item.itemsCompleted['percentage'])+"%, $"+count;
      }
      let cancledData = item.itemsCanceled ? true : false;
      let cancledDataVal = '-';
      if(cancledData){
        let count = this.commonService.numberWithCommasThreeDigit(Math.abs(item.itemsCanceled['count']).toFixed(2));
        cancledDataVal =  Math.round(item.itemsCanceled['percentage'])+"%, $"+count;
      }
  
      dealerInfo = [shopId, shopName, city, state,marketName, salesRepStr, scans, estimateDataVal,approvedDataVal,completeDataVal,cancledDataVal];

      this.dealerData.push(dealerInfo);      
    });

    //Create workbook and worksheet
    let workbook = new Workbook();
    let sheetName = `${this.title} Report`;
    sheetName = sheetName;
    let worksheet = workbook.addWorksheet(sheetName);
    //let worksheet2 = workbook.addWorksheet('Sheet 2');

    //Add Row and formatting
    let titleRow = worksheet.addRow([sheetName]);
    titleRow.font = { name: 'Calibri', family: 4, size: 16, bold: true }           

    let sdate = '', edate = '';
    sdate = this.apiData["startDate"];
    edate = this.apiData["endDate"];
    
    if(sdate != '' && edate != ''){
      let startDate = moment.utc(sdate).toDate();
      sdate = moment(startDate).local().format('MMM DD, YYYY');
      let endDate = moment.utc(edate).toDate();
      edate = moment(endDate).local().format('MMM DD, YYYY');
      let subTitleRow = "Date Range : " +sdate+ ' to ' +edate;

      //worksheet.addRow([]);
      //Add Row and formatting
      let subTitleRow1 = worksheet.addRow([subTitleRow]);
      subTitleRow1.font = { name: 'Calibri', family: 4, size: 12, bold: true}
    }
    //Blank Row 
    worksheet.addRow([]);
    
    // Add Header Row
    let headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        //fgColor: { argb: 'FFFFFF00' },
        fgColor: { argb: 'e8e3e3' },
        
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    });

    // Add Data and Conditional Formatting
    this.dealerData.forEach((d, dindex) => {
      worksheet.addRow(d);        
    });

    worksheet.getColumn(1).width = (this.arAgingFlag) ? 50 : 12;
    worksheet.getColumn(1).alignment = {
      horizontal: 'left'
    }       


      worksheet.getColumn(2).width = 40;
      worksheet.getColumn(3).width = 20;
      worksheet.getColumn(4).width = 20;
      worksheet.getColumn(5).width = 20;
      worksheet.getColumn(6).width = 30;
      worksheet.getColumn(7).width = 15;
      worksheet.getColumn(8).width = 26; 
      worksheet.getColumn(9).width = 26; 
      worksheet.getColumn(10).width = 26; 
      worksheet.getColumn(11).width = 26;
      worksheet.getColumn(7).alignment = {
        horizontal: 'right'
      }
      worksheet.getColumn(8).alignment = {
        horizontal: 'right'
      }
      worksheet.getColumn(9).alignment = {
        horizontal: 'right'
      }
      worksheet.getColumn(10).alignment = {
        horizontal: 'right'
      }
      worksheet.getColumn(11).alignment = {
        horizontal: 'right'
      }
    
    worksheet.addRow([]);

    if(this.exceldownloadtrue) {
      this.progressbarCount='100';
      this.progressbarCountWidth=this.progressbarCount+'%';
      this.downloadtextflag='Export complete.';
      
      setTimeout(() => {
        //Generate Excel File with given name
        workbook.xlsx.writeBuffer().then((data) => {
          let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          fs.saveAs(blob, `${sheetName}_${this.currDateTime}.xlsx`);
        });
        this.exceldownloadtrue=false; 
        this.stopexportapi=true;
        this.itemOffset=0;
        this.dealerData=[];
        this.progressbarCount='0';
        this.progressbarCountWidth=this.progressbarCount+'%';
        this.downloadtextflag='Exporting data to Excel..';
        this.updateonExportisDone.emit(1);
      },3000);
    } else {
      this.exportSalesReport();
    } 
  }
  exportRoReportFilterData(title, exportData){
    console.log(exportData)
    let apiData = exportData;
    let shortTitle = this.apiData['shortTitle'];
    let roIdCol = `${shortTitle} ID#`;
    let roDateCol = `${shortTitle} Date`;
    let shopRoCol = `Shop ${shortTitle}`;
    let header:any = [];
    if(this.salesType1ReportFlag) {
      header = [roIdCol, 'VIN', 'Vehicle', 'Operations','Sales Rep', 'Scan Date',  'Estimate Sent', 'Approved', 'Complete' , 'Canceled', 'Amount'];
    }else if(this.salesType2ReportFlag) {
      header = [roIdCol, roDateCol, 'Customer Name', shopRoCol, 'ADAS Impacted?', 'Market', 'Sales Rep', 'Status'];
    }else if(this.scanReportFlag) {
      header = [roIdCol, 'Customer Name', shopRoCol, 'Location', 'Vehicle', 'ADAS Impacted?', 'Scanned By', roDateCol, 'Status'];
    } else if(this.arAgingFlag){
      header = ['Customer Name', roIdCol, shopRoCol, 'Sales Rep', 'Market', 'Last Invoice Date', 'Current', 'Over 30', 'Over 45', 'Over 60', 'Over 90'];
    } else {
      header = [roIdCol, 'Customer Name', shopRoCol, 'Location', 'Vehicle', roDateCol, 'Status'];
    }
    
    let dealerInfo:any=[];
    apiData.forEach(item => {  

      let days1:any = '',days2:any = '',days3:any = '', amount='',completionData:any = '',roEstimateDate:any = '',roApprovalDate:any = '',approvalData:any='-',estimateData:any = '-';    
      let roCreatedDate:any = '', roCompletedDate:any = '', locationStr = '', shopNumberStr = '', vehicleStr = '', statusStr = '', statusBgColorStr = '';
      let roBusinessNameStr = '-', roBusinessCityStr = '-', roBusinessStateStr = '-', market = '-', marketNameStr = '',  salesRep = '-',  salesRepNameStr='-', createdOnStr: any = '-', scanDate: any = '-', estimateDate:any = '-', estimateValue:any = '-', approvalDate:any = '-', completionDate:any = '-', cycleTime = '-';
      let businessInfoJsonArr = (item.businessInfoJsonArr && item.businessInfoJsonArr != undefined) ? (item.businessInfoJsonArr) : '';
      let statusInfoJsonStr = (item.workOrderStatusInfoJsonArr && item.workOrderStatusInfoJsonArr != undefined) ? (item.workOrderStatusInfoJsonArr) : '';      let make = (item.make && item.make != undefined) ? item.make : '';
      let roId = item.roIdInt;
      let vinStr = item.vinStr && item.vinStr != '' && item.vinStr != '0' ? item.vinStr : ''; 
      let model = (item.model && item.model != undefined) ? item.model : '';
      let year = (item.year && item.year != undefined) ? item.year : '';
      let vehicle = '-';
      let serialNumberStr = (item.serialNumberStr && item.serialNumberStr != undefined) ? item.serialNumberStr : '';
      vehicle = (make != '') ? make : vehicle;
      vehicle = (model != '') ? `${vehicle}, ${model}` : vehicle;
      vehicle = (year != '') ? `${vehicle}, ${year}` : vehicle;
      if(item.threadCategoryInt == 10 && serialNumberStr != '' && serialNumberStr != 'undefined') {
        vehicle = `${vehicle}, ${serialNumberStr}`;
      }
      vehicleStr = vehicle;
      if(businessInfoJsonArr != '') {
        let business = businessInfoJsonArr[0];
        if(business){
          roBusinessNameStr = business.name != '' ? business.name : '-' ;
          roBusinessCityStr =  business.city != '' ? business.city : '' ;
          roBusinessStateStr =  business.state != '' ? business.state : '';
          locationStr = (roBusinessStateStr != '') ? `${roBusinessCityStr}, ${roBusinessStateStr}` : roBusinessCityStr;
        }        
      }
      if(statusInfoJsonStr != '') {
        let status = statusInfoJsonStr[0];
        statusStr = (item.deleteStatusInt == 1) ? 'Cancel' : status.statusName;
        statusBgColorStr = (item.deleteStatusInt == 1) ? '#f47070' : status.bgColor;
      }
      let marketId = item.marketIdInt;
      marketNameStr = (marketId > 0 && item.marketNameStr != null && item.marketNameStr != undefined && item.marketNameStr != '') ? item.marketNameStr : market;
      let salesRepId = item.salesRepIdInt;
      salesRepNameStr = (salesRepId > 0 && item.salesRepNameStr != null && item.salesRepNameStr != undefined && item.salesRepNameStr != '') ? item.salesRepNameStr : salesRep;
      shopNumberStr = (item.referenceShopROStr && item.referenceShopROStr != undefined) ? item.referenceShopROStr.toString() : '-';
      if(item.createdOnStr && (item.createdOnStr != null || item.createdOnStr != undefined || item.createdOnStr != '' || item.createdOnStr !='0000-00-00 00:00:00')){ 
        let createdOn = moment.utc(item.createdOnStr).toDate();
        createdOnStr = moment(createdOn).local().format('MMM DD, YYYY');
        roCreatedDate = moment(createdOn).local().format('MMM DD, YYYY h:mm A');
      }

      if(item.approvedDateStr && (item.approvedDateStr != null || item.approvedDateStr != undefined || item.approvedDateStr != '' || item.approvedDateStr !='0000-00-00 00:00:00')){ 
        let approvedOn = moment.utc(item.approvedDateStr).toDate();
        approvalDate = moment(approvedOn).local().format('MMM DD, YYYY');
      }

      if(item.completedDateStr && (item.completedDateStr != null || item.completedDateStr != undefined || item.completedDateStr != '' || item.completedDateStr !='0000-00-00 00:00:00')){
        let completedOn = moment.utc(item.completedDateStr).toDate();
        completionDate = moment(completedOn).local().format('MMM DD, YYYY');
        roCompletedDate = moment(completedOn).local().format('MMM DD, YYYY h:mm A');
      }

      if(item.estimateInfoDataJsonArr && (item.estimateInfoDataJsonArr != null || item.estimateInfoDataJsonArr != undefined || item.estimateInfoDataJsonArr != '')) {
        let estimateDataInfo = item.estimateInfoDataJsonArr[0];
        let estimateCreatedOn = estimateDataInfo.createdOn;
        let estDate = moment.utc(estimateCreatedOn).toDate();
        estimateDate = moment(estDate).local().format('MMM DD, YYYY');
      }

      if(item.estimationDataJsonArr && (item.estimationDataJsonArr != null || item.estimationDataJsonArr != undefined || item.estimationDataJsonArr != '')) {
        let estimateData = item.estimationDataJsonArr[0];
        let estimateTotal = estimateData.estimationTotal;
        estimateValue = (estimateTotal != '') ? `$${estimateTotal}` : '-';
        estimateDate = (estimateTotal != '') ? estimateDate : '-';
      }

      if(createdOnStr != '' && completionDate != '') {
        let startDate = new Date(roCreatedDate).getTime();
        let endDate = new Date(roCompletedDate).getTime();
        let differenceInMs: number = endDate - startDate;
        let millisecondsInDay: number = 1000 * 60 * 60 * 24;
        let differenceInDays: number = Math.ceil(differenceInMs / millisecondsInDay);
        let millisecondsInHours: number = 1000 * 60 * 60;
        let differenceInHours: number = Math.floor(differenceInMs / millisecondsInHours);
        let millisecondsInMins: number = 1000 * 60;
        let differenceInMins: number = Math.floor(differenceInMs / millisecondsInMins);
        if(differenceInDays > 0) {
          let dayText = (differenceInDays > 1) ? 'Days' : 'Day';
          cycleTime = `${differenceInDays} ${dayText}`;
        } else {
          cycleTime = '1 Day';
        }
      }

      let currentDate = moment().format();
      let currentAmount:any = 0;
      let invoiceDate = (item.invoiceDateStr != '0000-00-00 00:00:00') ? item.invoiceDateStr : currentDate;
      invoiceDate = moment.utc(invoiceDate).toDate();
      let localinvoiceDateformat = moment(invoiceDate).local().format("MM/DD/YY HH:mm:ss");
      invoiceDate = moment(localinvoiceDateformat).format("MMM DD, YYYY h:mm A");
      let current:any = '-', over30:any = '-', over45:any = '-', over60:any = '-', over90:any = '-';
      if(this.arAgingFlag) {
       let estimateHistory = item.estimateHistoryJsonArr;
        if(estimateHistory) {
          estimateHistory.forEach((hitem, index) => {
            if(index == 0) {
              currentAmount = hitem.total;
            }
          });
        }
        item['currentAmount'] = currentAmount;
        let currentDate = moment().format();
        let invoiceDate = (item.invoiceDateStr != '0000-00-00 00:00:00') ? item.invoiceDateStr : currentDate;
        invoiceDate = moment.utc(invoiceDate).toDate();
        let localinvoiceDateformat = moment(invoiceDate).local().format("MM/DD/YY HH:mm:ss");
        console.log(localinvoiceDateformat)
        invoiceDate = moment(localinvoiceDateformat).format("MMM DD, YYYY h:mm A");
        let invoiceDiff = moment.utc(currentDate).diff(localinvoiceDateformat, 'days');
        current = (invoiceDiff < 30) ? `${item.currentAmount}` : '-'; 
        over30 = (invoiceDiff > 30 && invoiceDiff <= 45) ? `${item.currentAmount}` : '-';
        over45 =  (invoiceDiff > 45 && invoiceDiff <= 60) ? `${item.currentAmount}` : '-';
        over60 =  (invoiceDiff > 60 && invoiceDiff <= 90) ? `${item.currentAmount}` : '-';
        over90 =  (invoiceDiff > 90) ? `${item.currentAmount}` : '-';              
      }

      let adasImpactedStr = item.adasImpactedStr;
      let scannedByStr = item.scannedByStr = (item.scannedByStr && item.scannedByStr != undefined) ? item.scannedByStr : '-';
      
      let operations = '-';
      let canceled = item.deleteStatusInt == 1 ? 'Yes' : 'No';

      if(this.salesType1ReportFlag) {
        if(item.createdOnStr && (item.createdOnStr != null || item.createdOnStr != undefined || item.createdOnStr != '' || item.createdOnStr !='0000-00-00 00:00:00')){ 
          let createdOn = moment.utc(item.createdOnStr).toDate();
          createdOnStr = moment(createdOn).local().format('MMM DD');
          roCreatedDate = moment(createdOn).local().format('MMM DD, YYYY h:mm A');
        }

        if(item.approvedDateStr && (item.approvedDateStr != null || item.approvedDateStr != undefined || item.approvedDateStr != '' || item.approvedDateStr !='0000-00-00 00:00:00')){ 
          let approvedOn = moment.utc(item.approvedDateStr).toDate();
          approvalDate = moment(approvedOn).local().format('MMM DD');
          roApprovalDate = moment(approvedOn).local().format('MMM DD, YYYY h:mm A');
          let dayCal = '';
          if(roCreatedDate != '' && roApprovalDate != '') {
            let startDate = new Date(roCreatedDate).getTime();
            let endDate = new Date(roApprovalDate).getTime();
            let differenceInMs: number = endDate - startDate;
            let millisecondsInDay: number = 1000 * 60 * 60 * 24;
            let differenceInDays: number = Math.ceil(differenceInMs / millisecondsInDay);
            if(differenceInDays > 0) {
              let dayText = (differenceInDays > 1) ? 'Days' : 'Day';
              dayCal = `(${differenceInDays} ${dayText})`;
            } else {
              dayCal = '(1 Day)';
            }
            days1 = `${dayCal}`;
          }
          approvalData = approvalDate+" "+days1;
        }
        
        

        if(item.completedDateStr && (item.completedDateStr != null || item.completedDateStr != undefined || item.completedDateStr != '' || item.completedDateStr !='0000-00-00 00:00:00')){
          let completedOn = moment.utc(item.completedDateStr).toDate();
          completionDate = moment(completedOn).local().format('MMM DD');
          roCompletedDate = moment(completedOn).local().format('MMM DD, YYYY h:mm A');
          let dayCal = '';
          if(roCreatedDate != '' && roCompletedDate != '') {
            let startDate = new Date(roCreatedDate).getTime();
            let endDate = new Date(roCompletedDate).getTime();
            let differenceInMs: number = endDate - startDate;
            let millisecondsInDay: number = 1000 * 60 * 60 * 24;
            let differenceInDays: number = Math.ceil(differenceInMs / millisecondsInDay);
            if(differenceInDays > 0) {
              let dayText = (differenceInDays > 1) ? 'Days' : 'Day';
              dayCal = `(${differenceInDays} ${dayText})`;
            } else {
              dayCal = '(1 Day)';
            }
            days2 = `${dayCal}`;
          }
          completionData = completionDate+" "+days2;
        }

        if(item.estimateInfoDataJsonArr && (item.estimateInfoDataJsonArr != null || item.estimateInfoDataJsonArr != undefined || item.estimateInfoDataJsonArr != '')) {
          let estimateDataInfo = item.estimateInfoDataJsonArr[0];
          if(estimateDataInfo.estimateData && estimateDataInfo.estimateData.length>0 && estimateDataInfo.isManual == 0){
            let estimateCreatedOn = estimateDataInfo.createdOn;
            let estDate = moment.utc(estimateCreatedOn).toDate();
            estimateDate = moment(estDate).local().format('MMM DD');
            roEstimateDate = moment(estDate).local().format('MMM DD, YYYY h:mm A');
            let dayCal = '';
            if(roCreatedDate != '' && roEstimateDate != '') {
              let startDate = new Date(roCreatedDate).getTime();
              let endDate = new Date(roEstimateDate).getTime();
              let differenceInMs: number = endDate - startDate;
              let millisecondsInDay: number = 1000 * 60 * 60 * 24;
              let differenceInDays: number = Math.ceil(differenceInMs / millisecondsInDay);
              if(differenceInDays > 0) {
                let dayText = (differenceInDays > 1) ? 'Days' : 'Day';
                dayCal = `(${differenceInDays} ${dayText})`;
              } else {
                dayCal = '(1 Day)';
              }
              days3 = `${dayCal}`;
            }
            estimateData = estimateDate+" "+days3;
          }
        }

        if(item.estimationDataJsonArr && (item.estimationDataJsonArr != null || item.estimationDataJsonArr != undefined || item.estimationDataJsonArr != '')) {
          let estimateData1 = item.estimationDataJsonArr[0];
          let estimateTotal = estimateData1.estimationTotal;
          estimateTotal = (estimateTotal != '') ? this.commonService.numberWithCommasThreeDigit(Math.abs(estimateTotal).toFixed(2)) : '';
          amount = (estimateTotal != '') ? `$${estimateTotal}` : '-';
          estimateDate = (estimateTotal != '') ? estimateDate : '-';
        }           
      }

      if(this.salesType1ReportFlag) {
        dealerInfo = [roId, vinStr, vehicleStr, operations, salesRepNameStr, createdOnStr,  estimateData, approvalData, completionData, canceled, amount];
      } else if(this.salesType2ReportFlag) {
        dealerInfo = [roId, roCreatedDate, roBusinessNameStr, shopNumberStr, adasImpactedStr, marketNameStr, salesRepNameStr, statusStr];
      } else if(this.scanReportFlag) {
        dealerInfo = [roId, roBusinessNameStr, shopNumberStr, locationStr, vehicleStr, adasImpactedStr, scannedByStr, createdOnStr, statusStr];
      } else if(this.arAgingFlag) {
        dealerInfo = [roBusinessNameStr, roId, shopNumberStr, salesRepNameStr, marketNameStr, invoiceDate, current, over30, over45, over60, over90];
      } else {
        dealerInfo = [roId, roBusinessNameStr, shopNumberStr, locationStr, vehicleStr, createdOnStr, statusStr];
      }
      this.dealerData.push(dealerInfo);      
    });

    //Create workbook and worksheet
    let workbook = new Workbook();
    let sheetName = `${shortTitle} Report`;
    sheetName = (this.arAgingFlag) ? `AR Aging - ${sheetName}` : sheetName;
    let worksheet = workbook.addWorksheet(sheetName);
    //let worksheet2 = workbook.addWorksheet('Sheet 2');

    //Add Row and formatting
    let titleRow = worksheet.addRow([sheetName]);
    titleRow.font = { name: 'Calibri', family: 4, size: 16, bold: true }           

    let sdate = '', edate = '';
    if(this.serviceRecordObjData["filterDates"] != '' && this.serviceRecordObjData["filterDates"] != undefined) {
      sdate = this.serviceRecordObjData["filterDates"][0]['value1'];
      edate = this.serviceRecordObjData["filterDates"][0]['value2'];
    } 
    
    if(sdate != '' && edate != ''){
      let startDate = moment.utc(sdate).toDate();
      sdate = moment(startDate).local().format('MMM DD, YYYY');
      let endDate = moment.utc(edate).toDate();
      edate = moment(endDate).local().format('MMM DD, YYYY');
      let subTitleRow = "Date Range : " +sdate+ ' to ' +edate;

      //worksheet.addRow([]);
      //Add Row and formatting
      let subTitleRow1 = worksheet.addRow([subTitleRow]);
      subTitleRow1.font = { name: 'Calibri', family: 4, size: 12, bold: true}
    }
    //Blank Row 
    worksheet.addRow([]);
    
    // Add Header Row
    let headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        //fgColor: { argb: 'FFFFFF00' },
        fgColor: { argb: 'e8e3e3' },
        
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    });

    // Add Data and Conditional Formatting
    this.dealerData.forEach((d, dindex) => {
      worksheet.addRow(d);        
    });

    worksheet.getColumn(1).width = (this.arAgingFlag) ? 50 : 12;
    worksheet.getColumn(1).alignment = {
      horizontal: 'left'
    }         
    if(this.salesType1ReportFlag){
      worksheet.getColumn(2).width = 25;
      worksheet.getColumn(3).width = 40;
      worksheet.getColumn(4).width = 15;
      worksheet.getColumn(5).width = 25;
      worksheet.getColumn(6).width = 15;
      worksheet.getColumn(7).width = 22;
      worksheet.getColumn(8).width = 22; 
      worksheet.getColumn(9).width = 22; 
      worksheet.getColumn(10).width = 15; 
      worksheet.getColumn(11).width = 22; 
      worksheet.getColumn(11).alignment = {
        horizontal: 'right'
      }
    } else if(this.salesType2ReportFlag){
      worksheet.getColumn(2).width = 30;
      worksheet.getColumn(3).width = 50;
      worksheet.getColumn(4).width = 15;
      worksheet.getColumn(5).width = 15;
      worksheet.getColumn(6).width = 25;
      worksheet.getColumn(7).width = 25;
      worksheet.getColumn(8).width = 22; 
    } else if(this.scanReportFlag){
      worksheet.getColumn(2).width = 50;
      worksheet.getColumn(3).width = 15;
      worksheet.getColumn(4).width = 30;
      worksheet.getColumn(5).width = 40;
      worksheet.getColumn(6).width = 15;
      worksheet.getColumn(7).width = 30;
      worksheet.getColumn(8).width = 20;
      worksheet.getColumn(9).width = 20;      
    } else if(this.arAgingFlag){
      worksheet.getColumn(2).width = 10;
      worksheet.getColumn(2).alignment = {
        horizontal: 'left'
      }
      worksheet.getColumn(3).width = 15;
      worksheet.getColumn(4).width = 25;
      worksheet.getColumn(5).width = 25;
      worksheet.getColumn(6).width = 25;
      worksheet.getColumn(7).width = 15;
      worksheet.getColumn(8).width = 15;
      worksheet.getColumn(9).width = 15;  
      worksheet.getColumn(10).width = 15;
      worksheet.getColumn(11).width = 15;
    } else{
      worksheet.getColumn(2).width = 50;
      worksheet.getColumn(3).width = 15;
      worksheet.getColumn(4).width = 30;
      worksheet.getColumn(5).width = 40;
      worksheet.getColumn(6).width = 20;
      worksheet.getColumn(7).width = 20;
    }
    worksheet.addRow([]);

    if(this.exceldownloadtrue) {
      this.progressbarCount='100';
      this.progressbarCountWidth=this.progressbarCount+'%';
      this.downloadtextflag='Export complete.';
      
      setTimeout(() => {
        //Generate Excel File with given name
        workbook.xlsx.writeBuffer().then((data) => {
          let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          fs.saveAs(blob, `${sheetName}_${this.currDateTime}.xlsx`);
        });
        this.exceldownloadtrue=false; 
        this.stopexportapi=true;
        this.itemOffset=0;
        this.dealerData=[];
        this.progressbarCount='0';
        this.progressbarCountWidth=this.progressbarCount+'%';
        this.downloadtextflag='Exporting data to Excel..';
        this.updateonExportisDone.emit(1);
      },3000);
    } else {
      this.exportRoReportFilter();
    } 
  }

  exportRoReportData(title, exportData) {
    console.log(exportData)
    let apiData = exportData;
    let shortTitle = this.apiData['shortTitle'];
    let roIdCol = `${shortTitle} ID#`;
    let roDateCol = `${shortTitle} Date`;
    let shopRoCol = `Shop ${shortTitle}`;
    let header:any = [];
    if(this.salesType1ReportFlag) {
      header = [roIdCol, 'VIN', 'Vehicle', 'Operations','Sales Rep', 'Scan Date',  'Estimate Sent', 'Approved', 'Complete' , 'Canceled', 'Amount'];
    }else if(this.salesType2ReportFlag) {
      header = [roIdCol, roDateCol, 'Customer Name', shopRoCol, 'ADAS Impacted?', 'Market', 'Sales Rep', 'Status'];
    }else if(this.scanReportFlag) {
      header = [roIdCol, 'Customer Name', shopRoCol, 'Location', 'Vehicle', 'ADAS Impacted?', 'Scanned By', roDateCol, 'Status'];
    } else if(this.arAgingFlag){
      header = ['Customer Name', roIdCol, shopRoCol, 'Sales Rep', 'Market', 'Last Invoice Date', 'Current', 'Over 30', 'Over 45', 'Over 60', 'Over 90'];
    } else {
      header = [roIdCol, 'Customer Name', shopRoCol, 'Location', 'Vehicle', roDateCol, 'Status'];
    }
    
    let dealerInfo:any=[];
    apiData.forEach(item => {  

      let days1:any = '',days2:any = '',days3:any = '', amount='',completionData:any = '',roEstimateDate:any = '',roApprovalDate:any = '',approvalData:any='-',estimateData:any = '-';    
      let roCreatedDate:any = '', roCompletedDate:any = '', locationStr = '', shopNumberStr = '', vehicleStr = '', statusStr = '', statusBgColorStr = '';
      let roBusinessNameStr = '-', roBusinessCityStr = '-', roBusinessStateStr = '-', market = '-', marketNameStr = '',  salesRep = '-',  salesRepNameStr='-', createdOnStr: any = '-', scanDate: any = '-', estimateDate:any = '-', estimateValue:any = '-', approvalDate:any = '-', completionDate:any = '-', cycleTime = '-';
      let businessInfoJsonArr = (item.businessInfoJsonArr && item.businessInfoJsonArr != undefined) ? (item.businessInfoJsonArr) : '';
      let statusInfoJsonStr = (item.workOrderStatusInfoJsonArr && item.workOrderStatusInfoJsonArr != undefined) ? (item.workOrderStatusInfoJsonArr) : '';      let make = (item.make && item.make != undefined) ? item.make : '';
      let roId = item.roIdInt;
      let vinStr = item.vinStr && item.vinStr != '' && item.vinStr != '0' ? item.vinStr : ''; 
      let model = (item.model && item.model != undefined) ? item.model : '';
      let year = (item.year && item.year != undefined) ? item.year : '';
      let vehicle = '-';
      let serialNumberStr = (item.serialNumberStr && item.serialNumberStr != undefined) ? item.serialNumberStr : '';
      vehicle = (make != '') ? make : vehicle;
      vehicle = (model != '') ? `${vehicle}, ${model}` : vehicle;
      vehicle = (year != '') ? `${vehicle}, ${year}` : vehicle;
      if(item.threadCategoryInt == 10 && serialNumberStr != '' && serialNumberStr != 'undefined') {
        vehicle = `${vehicle}, ${serialNumberStr}`;
      }
      vehicleStr = vehicle;
      if(businessInfoJsonArr != '') {
        let business = businessInfoJsonArr[0];
        if(business){
          roBusinessNameStr = business.name != '' ? business.name : '-' ;
          roBusinessCityStr =  business.city != '' ? business.city : '' ;
          roBusinessStateStr =  business.state != '' ? business.state : '';
          locationStr = (roBusinessStateStr != '') ? `${roBusinessCityStr}, ${roBusinessStateStr}` : roBusinessCityStr;
        }        
      }
      if(statusInfoJsonStr != '') {
        let status = statusInfoJsonStr[0];
        statusStr = (this.salesType2ReportFlag && item.deleteStatusInt == 1) ? 'Cancel' : status.statusName;
        statusBgColorStr = (this.salesType2ReportFlag && item.deleteStatusInt == 1) ? '#f47070' : status.bgColor;
      }
      let marketId = item.marketIdInt;
      marketNameStr = (marketId > 0 && item.marketNameStr != null && item.marketNameStr != undefined && item.marketNameStr != '') ? item.marketNameStr : market;
      let salesRepId = item.salesRepIdInt;
      salesRepNameStr = (salesRepId > 0 && item.salesRepNameStr != null && item.salesRepNameStr != undefined && item.salesRepNameStr != '') ? item.salesRepNameStr : salesRep;
      shopNumberStr = (item.referenceShopROStr && item.referenceShopROStr != undefined) ? item.referenceShopROStr.toString() : '-';
      if(item.createdOnStr && (item.createdOnStr != null || item.createdOnStr != undefined || item.createdOnStr != '' || item.createdOnStr !='0000-00-00 00:00:00')){ 
        let createdOn = moment.utc(item.createdOnStr).toDate();
        createdOnStr = moment(createdOn).local().format('MMM DD, YYYY');
        roCreatedDate = moment(createdOn).local().format('MMM DD, YYYY h:mm A');
      }

      if(item.approvedDateStr && (item.approvedDateStr != null || item.approvedDateStr != undefined || item.approvedDateStr != '' || item.approvedDateStr !='0000-00-00 00:00:00')){ 
        let approvedOn = moment.utc(item.approvedDateStr).toDate();
        approvalDate = moment(approvedOn).local().format('MMM DD, YYYY');
      }

      if(item.completedDateStr && (item.completedDateStr != null || item.completedDateStr != undefined || item.completedDateStr != '' || item.completedDateStr !='0000-00-00 00:00:00')){
        let completedOn = moment.utc(item.completedDateStr).toDate();
        completionDate = moment(completedOn).local().format('MMM DD, YYYY');
        roCompletedDate = moment(completedOn).local().format('MMM DD, YYYY h:mm A');
      }

      if(item.estimateInfoDataJsonArr && (item.estimateInfoDataJsonArr != null || item.estimateInfoDataJsonArr != undefined || item.estimateInfoDataJsonArr != '')) {
        let estimateDataInfo = item.estimateInfoDataJsonArr[0];
        let estimateCreatedOn = estimateDataInfo.createdOn;
        let estDate = moment.utc(estimateCreatedOn).toDate();
        estimateDate = moment(estDate).local().format('MMM DD, YYYY');
      }

      if(item.estimationDataJsonArr && (item.estimationDataJsonArr != null || item.estimationDataJsonArr != undefined || item.estimationDataJsonArr != '')) {
        let estimateData = item.estimationDataJsonArr[0];
        let estimateTotal = estimateData.estimationTotal;
        estimateValue = (estimateTotal != '') ? `$${estimateTotal}` : '-';
        estimateDate = (estimateTotal != '') ? estimateDate : '-';
      }

      if(createdOnStr != '' && completionDate != '') {
        let startDate = new Date(roCreatedDate).getTime();
        let endDate = new Date(roCompletedDate).getTime();
        let differenceInMs: number = endDate - startDate;
        let millisecondsInDay: number = 1000 * 60 * 60 * 24;
        let differenceInDays: number = Math.ceil(differenceInMs / millisecondsInDay);
        let millisecondsInHours: number = 1000 * 60 * 60;
        let differenceInHours: number = Math.floor(differenceInMs / millisecondsInHours);
        let millisecondsInMins: number = 1000 * 60;
        let differenceInMins: number = Math.floor(differenceInMs / millisecondsInMins);
        if(differenceInDays > 0) {
          let dayText = (differenceInDays > 1) ? 'Days' : 'Day';
          cycleTime = `${differenceInDays} ${dayText}`;
        } else {
          cycleTime = '1 Day';
        }
      }

      let currentDate = moment().format();
      let currentAmount:any = 0;
      let invoiceDate = (item.invoiceDateStr != '0000-00-00 00:00:00') ? item.invoiceDateStr : currentDate;
      invoiceDate = moment.utc(invoiceDate).toDate();
      let localinvoiceDateformat = moment(invoiceDate).local().format("MM/DD/YY HH:mm:ss");
      invoiceDate = moment(localinvoiceDateformat).format("MMM DD, YYYY h:mm A");
      let current:any = '-', over30:any = '-', over45:any = '-', over60:any = '-', over90:any = '-';
      if(this.arAgingFlag) {
       let estimateHistory = item.estimateHistoryJsonArr;
        if(estimateHistory) {
          estimateHistory.forEach((hitem, index) => {
            if(index == 0) {
              currentAmount = hitem.total;
            }
          });
        }
        item['currentAmount'] = currentAmount;
        let currentDate = moment().format();
        let invoiceDate = (item.invoiceDateStr != '0000-00-00 00:00:00') ? item.invoiceDateStr : currentDate;
        invoiceDate = moment.utc(invoiceDate).toDate();
        let localinvoiceDateformat = moment(invoiceDate).local().format("MM/DD/YY HH:mm:ss");
        console.log(localinvoiceDateformat)
        invoiceDate = moment(localinvoiceDateformat).format("MMM DD, YYYY h:mm A");
        let invoiceDiff = moment.utc(currentDate).diff(localinvoiceDateformat, 'days');
        current = (invoiceDiff < 30) ? `${item.currentAmount}` : '-'; 
        over30 = (invoiceDiff > 30 && invoiceDiff <= 45) ? `${item.currentAmount}` : '-';
        over45 =  (invoiceDiff > 45 && invoiceDiff <= 60) ? `${item.currentAmount}` : '-';
        over60 =  (invoiceDiff > 60 && invoiceDiff <= 90) ? `${item.currentAmount}` : '-';
        over90 =  (invoiceDiff > 90) ? `${item.currentAmount}` : '-';              
      }

      let adasImpactedStr = item.adasImpactedStr;
      let scannedByStr = item.scannedByStr = (item.scannedByStr && item.scannedByStr != undefined) ? item.scannedByStr : '-';
      
      let operations = '-';
      let canceled = item.deleteStatusInt == 1 ? 'Yes' : 'No';

      if(this.salesType1ReportFlag) {
        if(item.createdOnStr && (item.createdOnStr != null || item.createdOnStr != undefined || item.createdOnStr != '' || item.createdOnStr !='0000-00-00 00:00:00')){ 
          let createdOn = moment.utc(item.createdOnStr).toDate();
          createdOnStr = moment(createdOn).local().format('MMM DD');
          roCreatedDate = moment(createdOn).local().format('MMM DD, YYYY h:mm A');
        }

        if(item.approvedDateStr && (item.approvedDateStr != null || item.approvedDateStr != undefined || item.approvedDateStr != '' || item.approvedDateStr !='0000-00-00 00:00:00')){ 
          let approvedOn = moment.utc(item.approvedDateStr).toDate();
          approvalDate = moment(approvedOn).local().format('MMM DD');
          roApprovalDate = moment(approvedOn).local().format('MMM DD, YYYY h:mm A');
          let dayCal = '';
          if(roCreatedDate != '' && roApprovalDate != '') {
            let startDate = new Date(roCreatedDate).getTime();
            let endDate = new Date(roApprovalDate).getTime();
            let differenceInMs: number = endDate - startDate;
            let millisecondsInDay: number = 1000 * 60 * 60 * 24;
            let differenceInDays: number = Math.ceil(differenceInMs / millisecondsInDay);
            if(differenceInDays > 0) {
              let dayText = (differenceInDays > 1) ? 'Days' : 'Day';
              dayCal = `(${differenceInDays} ${dayText})`;
            } else {
              dayCal = '(1 Day)';
            }
            days1 = `${dayCal}`;
          }
          approvalData = approvalDate+" "+days1;
        }
        
        

        if(item.completedDateStr && (item.completedDateStr != null || item.completedDateStr != undefined || item.completedDateStr != '' || item.completedDateStr !='0000-00-00 00:00:00')){
          let completedOn = moment.utc(item.completedDateStr).toDate();
          completionDate = moment(completedOn).local().format('MMM DD');
          roCompletedDate = moment(completedOn).local().format('MMM DD, YYYY h:mm A');
          let dayCal = '';
          if(roCreatedDate != '' && roCompletedDate != '') {
            let startDate = new Date(roCreatedDate).getTime();
            let endDate = new Date(roCompletedDate).getTime();
            let differenceInMs: number = endDate - startDate;
            let millisecondsInDay: number = 1000 * 60 * 60 * 24;
            let differenceInDays: number = Math.ceil(differenceInMs / millisecondsInDay);
            if(differenceInDays > 0) {
              let dayText = (differenceInDays > 1) ? 'Days' : 'Day';
              dayCal = `(${differenceInDays} ${dayText})`;
            } else {
              dayCal = '(1 Day)';
            }
            days2 = `${dayCal}`;
          }
          completionData = completionDate+" "+days2;
        }

        if(item.estimateInfoDataJsonArr && (item.estimateInfoDataJsonArr != null || item.estimateInfoDataJsonArr != undefined || item.estimateInfoDataJsonArr != '')) {
          let estimateDataInfo = item.estimateInfoDataJsonArr[0];
          if(estimateDataInfo.estimateData && estimateDataInfo.estimateData.length>0 && estimateDataInfo.isManual == 0){
            let estimateCreatedOn = estimateDataInfo.createdOn;
            let estDate = moment.utc(estimateCreatedOn).toDate();
            estimateDate = moment(estDate).local().format('MMM DD');
            roEstimateDate = moment(estDate).local().format('MMM DD, YYYY h:mm A');
            let dayCal = '';
            if(roCreatedDate != '' && roEstimateDate != '') {
              let startDate = new Date(roCreatedDate).getTime();
              let endDate = new Date(roEstimateDate).getTime();
              let differenceInMs: number = endDate - startDate;
              let millisecondsInDay: number = 1000 * 60 * 60 * 24;
              let differenceInDays: number = Math.ceil(differenceInMs / millisecondsInDay);
              if(differenceInDays > 0) {
                let dayText = (differenceInDays > 1) ? 'Days' : 'Day';
                dayCal = `(${differenceInDays} ${dayText})`;
              } else {
                dayCal = '(1 Day)';
              }
              days3 = `${dayCal}`;
            }
            estimateData = estimateDate+" "+days3;
          }
        }

        if(item.estimationDataJsonArr && (item.estimationDataJsonArr != null || item.estimationDataJsonArr != undefined || item.estimationDataJsonArr != '')) {
          let estimateData1 = item.estimationDataJsonArr[0];
          let estimateTotal = estimateData1.estimationTotal;
          estimateTotal = (estimateTotal != '') ? this.commonService.numberWithCommasThreeDigit(Math.abs(estimateTotal).toFixed(2)) : '';
          amount = (estimateTotal != '') ? `$${estimateTotal}` : '-';
          estimateDate = (estimateTotal != '') ? estimateDate : '-';
        }           
      }

      if(this.salesType1ReportFlag) {
        dealerInfo = [roId, vinStr, vehicleStr, operations, salesRepNameStr, createdOnStr,  estimateData, approvalData, completionData, canceled, amount];
      } else if(this.salesType2ReportFlag) {
        dealerInfo = [roId, roCreatedDate, roBusinessNameStr, shopNumberStr, adasImpactedStr, marketNameStr, salesRepNameStr, statusStr];
      } else if(this.scanReportFlag) {
        dealerInfo = [roId, roBusinessNameStr, shopNumberStr, locationStr, vehicleStr, adasImpactedStr, scannedByStr, createdOnStr, statusStr];
      } else if(this.arAgingFlag) {
        dealerInfo = [roBusinessNameStr, roId, shopNumberStr, salesRepNameStr, marketNameStr, invoiceDate, current, over30, over45, over60, over90];
      } else {
        dealerInfo = [roId, roBusinessNameStr, shopNumberStr, locationStr, vehicleStr, createdOnStr, statusStr];
      }
      this.dealerData.push(dealerInfo);      
    });

    //Create workbook and worksheet
    let workbook = new Workbook();
    let sheetName = `${this.title+' '+shortTitle} Report`;
    sheetName = (this.arAgingFlag) ? `AR Aging - ${sheetName}` : sheetName;
    let worksheet = workbook.addWorksheet(sheetName);
    //let worksheet2 = workbook.addWorksheet('Sheet 2');

    //Add Row and formatting
    let titleRow = worksheet.addRow([sheetName]);
    titleRow.font = { name: 'Calibri', family: 4, size: 16, bold: true }           

    let sdate = '', edate = '';
    if(this.apiData["filterDates"] != '' && this.apiData["filterDates"] != undefined) {
      sdate = this.apiData["filterDates"][0]['value1'];
      edate = this.apiData["filterDates"][0]['value2'];
    } 
    
    if(sdate != '' && edate != ''){
      let startDate = moment.utc(sdate).toDate();
      sdate = moment(startDate).local().format('MMM DD, YYYY');
      let endDate = moment.utc(edate).toDate();
      edate = moment(endDate).local().format('MMM DD, YYYY');
      let subTitleRow = "Date Range : " +sdate+ ' to ' +edate;

      //worksheet.addRow([]);
      //Add Row and formatting
      let subTitleRow1 = worksheet.addRow([subTitleRow]);
      subTitleRow1.font = { name: 'Calibri', family: 4, size: 12, bold: true}
    }
    //Blank Row 
    worksheet.addRow([]);
    
    // Add Header Row
    let headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        //fgColor: { argb: 'FFFFFF00' },
        fgColor: { argb: 'e8e3e3' },
        
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    });

    // Add Data and Conditional Formatting
    this.dealerData.forEach((d, dindex) => {
      worksheet.addRow(d);        
    });

    worksheet.getColumn(1).width = (this.arAgingFlag) ? 50 : 12;
    worksheet.getColumn(1).alignment = {
      horizontal: 'left'
    }         
    if(this.salesType1ReportFlag){
      worksheet.getColumn(2).width = 25;
      worksheet.getColumn(3).width = 40;
      worksheet.getColumn(4).width = 15;
      worksheet.getColumn(5).width = 25;
      worksheet.getColumn(6).width = 15;
      worksheet.getColumn(7).width = 22;
      worksheet.getColumn(8).width = 22; 
      worksheet.getColumn(9).width = 22; 
      worksheet.getColumn(10).width = 15; 
      worksheet.getColumn(11).width = 22; 
      worksheet.getColumn(11).alignment = {
        horizontal: 'right'
      }
    } else if(this.salesType2ReportFlag){
      worksheet.getColumn(2).width = 30;
      worksheet.getColumn(3).width = 50;
      worksheet.getColumn(4).width = 15;
      worksheet.getColumn(5).width = 15;
      worksheet.getColumn(6).width = 25;
      worksheet.getColumn(7).width = 25;
      worksheet.getColumn(8).width = 22; 
    } else if(this.scanReportFlag){
      worksheet.getColumn(2).width = 50;
      worksheet.getColumn(3).width = 15;
      worksheet.getColumn(4).width = 30;
      worksheet.getColumn(5).width = 40;
      worksheet.getColumn(6).width = 15;
      worksheet.getColumn(7).width = 30;
      worksheet.getColumn(8).width = 20;
      worksheet.getColumn(9).width = 20;      
    } else if(this.arAgingFlag){
      worksheet.getColumn(2).width = 10;
      worksheet.getColumn(2).alignment = {
        horizontal: 'left'
      }
      worksheet.getColumn(3).width = 15;
      worksheet.getColumn(4).width = 25;
      worksheet.getColumn(5).width = 25;
      worksheet.getColumn(6).width = 25;
      worksheet.getColumn(7).width = 15;
      worksheet.getColumn(8).width = 15;
      worksheet.getColumn(9).width = 15;  
      worksheet.getColumn(10).width = 15;
      worksheet.getColumn(11).width = 15;
    } else{
      worksheet.getColumn(2).width = 50;
      worksheet.getColumn(3).width = 15;
      worksheet.getColumn(4).width = 30;
      worksheet.getColumn(5).width = 40;
      worksheet.getColumn(6).width = 20;
      worksheet.getColumn(7).width = 20;
    }
    worksheet.addRow([]);

    if(this.exceldownloadtrue) {
      this.progressbarCount='100';
      this.progressbarCountWidth=this.progressbarCount+'%';
      this.downloadtextflag='Export complete.';
      
      setTimeout(() => {
        //Generate Excel File with given name
        workbook.xlsx.writeBuffer().then((data) => {
          let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          fs.saveAs(blob, `${sheetName}_${this.currDateTime}.xlsx`);
        });
        this.exceldownloadtrue=false; 
        this.stopexportapi=true;
        this.itemOffset=0;
        this.dealerData=[];
        this.progressbarCount='0';
        this.progressbarCountWidth=this.progressbarCount+'%';
        this.downloadtextflag='Exporting data to Excel..';
        this.updateonExportisDone.emit(1);
      },3000);
    } else {
      this.exportRoReport();
    } 
  }

  exportThreadReports(title, exportData) {
    let openThreadsData = exportData.openThreads;
    let closedThreadsData = exportData.closedThreads;
    let threadListData = exportData.threadList;

    let openHeader = ['Thread Status', 'Total Count', 'Percentage'];
    let openData = [];
    for(var openThread in openThreadsData) {
      let status = openThreadsData[openThread].title;
      let count = openThreadsData[openThread].countValue;
      let percentVal = openThreadsData[openThread].percentageValue+'%';
      let openThreadInfo = [status, count, percentVal];
      openData.push(openThreadInfo);
    }

    let closedHeader = ['Thread Status', 'Total Count', 'Percentage'];
    let closedData = [];
    for(var closedThread in closedThreadsData) {
      let status = closedThreadsData[closedThread].title;
      let count = closedThreadsData[closedThread].countValue;
      let percentVal = closedThreadsData[closedThread].percentageValue+'%';
      let closedThreadInfo = [status, count, percentVal];
      closedData.push(closedThreadInfo);
    }

    let threadTitle = title[1].charAt(0).toUpperCase() + title[1].slice(1);
    let threadListHeader;
    if(threadTitle == 'Open') {
      //threadListHeader = ['Dealer Name', 'ID', 'User Type', 'Zone', 'Area', 'TTY', 'Product Owner', 'TM Name', 'ASM Name',  'Thread Creation Date','Thread Creation Time','Day', 'Model > Year', 'Frame#', 'Odo Meter', 'Title', 'Error Code', 'Description', '1st reply - content', '2nd reply - content', '3rd reply - content', '4th reply - content', 'Final proposed fix content', 'No. of SIB checks available', 'Status', 'Esc Level', 'Proposed Fix Date', 'Proposed Fix Content', '1st Reply Time', 'Thread ID', 'Time to Share Proposed Fix (Product Co-ordinator) (Hrs)','Proposed Fix by TVS Employee/Agency','Person who posted the Proposed Fix','Time to Share First Reply from Produc Co-orindator (Hrs)','Time to Share First Reply from TVS Employee/Agency (Hrs)',   'Open/Closed', 'Workstreams', 'Feedback Status'];
      threadListHeader = ['Dealer Name', 'ID', 'Branch ID', 'Branch Name', 'User Type','Dealer City', 'Zone', 'Area', 'TTY', 'Product Owner', 'TM Name', 'ASM Name', 'Thread Posted By','Phone Number1', 'Phone Number2','Thread Creation Date','Thread Creation Time','Day', 'Model > Year', 'Frame#', 'Odo Meter', 'Title', 'Error Code', 'Description','Action Taken / Parts Replaced', '1st reply - content', '2nd reply - content', '3rd reply - content', '4th reply - content', 'Final proposed fix content', 'No. of SIB checks available', 'Status', 'Esc Level', 'Thread ID', 'Proposed Fix Date', 'Time to Share Proposed Fix by TVS Employee/Agency (Hrs)','Person who posted the Proposed Fix','Time to Share First Reply from TVS Employee/Agency (Hrs)', '1st Reply Time', '1st Response Given By',  'Open/Closed', 'Workstreams', 'Feedback Status', 'Rating Count', 'Quality Report'];
    } else {
      //threadListHeader = ['Dealer Name', 'ID', 'User Type', 'Zone', 'Area', 'TTY', 'Product Owner', 'TM Name', 'ASM Name', 'Thread Creation Date','Thread Creation Time','Day', 'Model > Year', 'Frame#', 'Odo Meter', 'Title', 'Error Code', 'Description', '1st reply - content', '2nd reply - content', '3rd reply - content', '4th reply - content', 'Final proposed fix content', 'No. of SIB checks available', 'Status', 'Esc Level', 'Proposed Fix Date',  'Proposed Fix Content', '1st Reply Time', 'Thread ID', 'Thread Closed Date', 'Time to Share Proposed Fix (Product Co-ordinator) (Hrs)','Proposed Fix by TVS Employee/Agency','Person who posted the Proposed Fix','Time to Share First Reply from Produc Co-orindator (Hrs)','Time to Share First Reply from TVS Employee/Agency (Hrs)', 'Time to Close (Hrs)','Time to Close (Days)',  'Open/Closed', 'Workstreams', 'Feedback Status'];
      threadListHeader = ['Dealer Name', 'ID','Branch ID', 'Branch Name', 'User Type','Dealer City', 'Zone', 'Area', 'TTY', 'Product Owner', 'TM Name', 'ASM Name', 'Thread Posted By','Phone Number1', 'Phone Number2','Thread Creation Date','Thread Creation Time','Day', 'Model > Year', 'Frame#', 'Odo Meter', 'Title', 'Error Code', 'Description','Action Taken / Parts Replaced', '1st reply - content', '2nd reply - content', '3rd reply - content', '4th reply - content', 'Final proposed fix content', 'No. of SIB checks available', 'Status', 'Esc Level', 'Thread ID', 'Thread Closed Date', 'Thread Closed By', 'Proposed Fix Date', 'Time to Share Proposed Fix by TVS Employee/Agency (Hrs)','Person who posted the Proposed Fix','Time to Share First Reply from TVS Employee/Agency (Hrs)', '1st Reply Time', '1st Response Given By', 'Time to Close (Hrs)','Time to Close (Days)',  'Open/Closed','Auto Closed?', 'Workstreams', 'Feedback Status', 'Rating Count', 'Quality Report'];
    }
   
    for(var threadList in threadListData) {
      let dealerName = threadListData[threadList].dealerName;
      let dealerCode = threadListData[threadList].dealerCode;
      let branchId = threadListData[threadList].branchId;
      let branchName = threadListData[threadList].branchName;
      let userTypeName = threadListData[threadList].userTypeName;
      let zone = threadListData[threadList].zone;
      let userarea = threadListData[threadList].userarea;
      let tty = threadListData[threadList].territory;
      let prodOwner = threadListData[threadList].assigneeFirstLastname;
      let tmName = threadListData[threadList].territory_manager;
      let asmName = (threadListData[threadList].asmName!='') ? threadListData[threadList].asmName[0]['assigneeFirstLastname'] : '-';
      let threadCreation = threadListData[threadList].created_on_new;
      let threadCreationDate = threadListData[threadList].created_on_date;
      let threadCreationTime = threadListData[threadList].created_on_time;      
      let threadCreationDay = threadListData[threadList].created_on_day;
      let model = threadListData[threadList].model+' > '+threadListData[threadList].year;
      let frame = threadListData[threadList].frameNo;
      let odoMeter = threadListData[threadList].odoMeter;
      let title = threadListData[threadList].title;
      let errorCode = threadListData[threadList].error_code;
      let desc = threadListData[threadList].description;
      let actionTaken = threadListData[threadList].actionTaken;
      let replyCont1 = threadListData[threadList].replyContent1;
      let replyCont2 = threadListData[threadList].replyContent2;
      let replyCont3 = threadListData[threadList].replyContent3;
      let replyCont4 = threadListData[threadList].replyContent4; 
      let lastPropsedFix = threadListData[threadList].lastPropsedFix;
      let similarSIBCount = threadListData[threadList].similarSIBCount;
      let threadStatus = threadListData[threadList].thread_status; 
      let escLevel = threadListData[threadList].escalate_status_land;
      let proposedFixDate = threadListData[threadList].proposedFix_createdOn_new;
      let firstTimeReply = threadListData[threadList].firstReplyFromEmpNew;
      //added by karuna for proposed fix content
      let proposedFix_content = threadListData[threadList].proposedFix_contentxls;
      let proposedFix_createdOnEmpandAgency = threadListData[threadList].proposedFix_createdOnEmpandAgency;
      let proposedFix_NameEmpandAgency = threadListData[threadList].proposedFix_NameEmpandAgency;

      // updated new  
      let firstReplyFromTVSEmployeeTimeV2 = threadListData[threadList].firstReplyFromTVSEmployeeTimeV2;      
      let firstReplyFromTVSEmployeeV2 = threadListData[threadList].firstReplyFromTVSEmployeeV2;      
      let proposedFixFromTVSEmployeeTimeV2 = threadListData[threadList].proposedFixFromTVSEmployeeTimeV2;      
      let proposedFixFromTVSEmployeeV2 = threadListData[threadList].proposedFixFromTVSEmployeeV2;
      let closedThreadTimeV2 = threadListData[threadList].closedThreadTimeV2;
      let closedThreadDaysV2 = threadListData[threadList].closedThreadDaysV2;
      let closedThreadDateV2 = threadListData[threadList].closedThreadDateV2;
      let proposedFix_NameEmpandAgencyV2 = threadListData[threadList].proposedFix_NameEmpandAgencyV2;
 
      let threadPostedBy = threadListData[threadList].threadPostedBy;      
      let endUserPhoneNo1 = threadListData[threadList].endUserPhoneNo;      
      let endUserPhoneNo2 = threadListData[threadList].endUserPhoneNo1;      
      let dealerCity = threadListData[threadList].dealerCity;      
      let firstResponseGivenBY = threadListData[threadList].firstResponseGivenBY;
      let threadClosedBy = threadListData[threadList].threadClosedBy;
      // updated new 

      //let threadId = '#'+threadListData[threadList].thread_id;
      let threadId = threadListData[threadList].thread_id;
      let timeToRespond = (threadListData[threadList].exportTimeToRespond == '-' || threadListData[threadList].exportTimeToRespond == '') ? 9999 : threadListData[threadList].exportTimeToRespond;
      let timeToProposedFix = (threadListData[threadList].exportTimeToProposedFix == '-' || threadListData[threadList].exportTimeToProposedFix == '') ? 9999 : threadListData[threadList].exportTimeToProposedFix;
      let timeToFisrtReplyProdCo = (threadListData[threadList].exportTimeToReplyProdCo == '-' || threadListData[threadList].exportTimeToReplyProdCo == '') ? 0 : threadListData[threadList].exportTimeToReplyProdCo;
      let timeToFisrtReplyTvsEmp = (threadListData[threadList].exportTimeToReplyTvsEmp == '-' || threadListData[threadList].exportTimeToReplyTvsEmp == '') ? 0 : threadListData[threadList].exportTimeToReplyTvsEmp;
      let timeclose_status = threadListData[threadList].close_status;
      let timeclose_autocloseStatus = threadListData[threadList].closedFrom;
      let workstreamsListthread = threadListData[threadList].workstreamsList;
      let feedbackStatus = threadListData[threadList].feedbackStatus;

      let qualityReport = threadListData[threadList].qualityReport;
      let ratingCount = threadListData[threadList].ratingCount;
      
      let timeToClose:any = 0;
      let dayToClose:any = 0;
      let openclosestatus='';
      let autocloseStatus='';
      if(timeclose_status == 1) {
        openclosestatus = 'Closed';
        if(timeclose_autocloseStatus!='')
        {
          autocloseStatus='Yes';
        }
        else
        {
          autocloseStatus='No';
        }
        
      } else {
        openclosestatus = 'Open';
      }
      
      let threadListInfo;
      if(threadTitle == 'Open') {
        //threadListInfo = [dealerName, dealerCode, userTypeName, zone, userarea, tty, prodOwner, tmName, asmName, threadCreationDate,threadCreationTime,threadCreationDay, model, frame, odoMeter, title, errorCode, desc, replyCont1, replyCont2, replyCont3, replyCont4, lastPropsedFix, similarSIBCount, threadStatus, escLevel, proposedFixDate, proposedFix_content, firstTimeReply, threadId, timeToRespond,timeToProposedFix, proposedFix_NameEmpandAgency, timeToFisrtReplyProdCo, timeToFisrtReplyTvsEmp, openclosestatus, workstreamsListthread, feedbackStatus];
        threadListInfo = [dealerName, dealerCode, branchId, branchName, userTypeName,dealerCity, zone, userarea, tty, prodOwner, tmName, asmName, threadPostedBy, endUserPhoneNo1, endUserPhoneNo2, threadCreationDate,threadCreationTime,threadCreationDay, model, frame, odoMeter, title, errorCode, desc, actionTaken, replyCont1, replyCont2, replyCont3, replyCont4, lastPropsedFix, similarSIBCount, threadStatus, escLevel, threadId,  proposedFixFromTVSEmployeeV2, proposedFixFromTVSEmployeeTimeV2, proposedFix_NameEmpandAgencyV2, firstReplyFromTVSEmployeeTimeV2, firstReplyFromTVSEmployeeV2, firstResponseGivenBY, openclosestatus, workstreamsListthread, feedbackStatus, ratingCount, qualityReport];
      } else {
        let threadCloseDate = threadListData[threadList].close_date_new;  
        timeToClose = (threadListData[threadList].exportTimeToClose == '-' || threadListData[threadList].exportTimeToClose == '') ? 0 : threadListData[threadList].exportTimeToClose;
        dayToClose = (threadListData[threadList].exportDayToClose == '-' || threadListData[threadList].exportDayToClose == '') ? 0 : threadListData[threadList].exportDayToClose;
        //threadListInfo = [dealerName, dealerCode, userTypeName, zone, userarea, tty, prodOwner, tmName, asmName, threadCreationDate,threadCreationTime,threadCreationDay, model, frame, odoMeter, title, errorCode, desc, replyCont1, replyCont2, replyCont3, replyCont4, lastPropsedFix, similarSIBCount, threadStatus, escLevel, proposedFixDate, proposedFix_content, firstTimeReply, threadId, threadCloseDate, timeToRespond,timeToProposedFix, proposedFix_NameEmpandAgency, timeToFisrtReplyProdCo, timeToFisrtReplyTvsEmp, timeToClose, dayToClose, openclosestatus, workstreamsListthread, feedbackStatus];
        threadListInfo = [dealerName, dealerCode, branchId, branchName, userTypeName,dealerCity, zone, userarea, tty, prodOwner, tmName, asmName, threadPostedBy, endUserPhoneNo1, endUserPhoneNo2, threadCreationDate,threadCreationTime,threadCreationDay, model, frame, odoMeter, title, errorCode, desc, actionTaken, replyCont1, replyCont2, replyCont3, replyCont4, lastPropsedFix, similarSIBCount, threadStatus, escLevel, threadId, closedThreadDateV2, threadClosedBy,  proposedFixFromTVSEmployeeV2, proposedFixFromTVSEmployeeTimeV2, proposedFix_NameEmpandAgencyV2, firstReplyFromTVSEmployeeTimeV2, firstReplyFromTVSEmployeeV2, firstResponseGivenBY, closedThreadTimeV2, closedThreadDaysV2, openclosestatus,autocloseStatus, workstreamsListthread, feedbackStatus, ratingCount, qualityReport];
      }
      
      this.threadLists.push(threadListInfo);
    }

    //Create workbook and worksheet
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet(title[0]);

    //Add Row and formatting
    let titleRow = worksheet.addRow([title[0]]);
    titleRow.font = { name: 'Comic Sans MS', family: 4, size: 16, bold: true }
    worksheet.addRow([]);
    //let subTitleRow = worksheet.addRow(['Date : ' + this.datePipe.transform(new Date(), 'medium')]);

    // Open Threads Data
    
    //Blank Row 
    worksheet.addRow([]);
    
    // Add Header Row
    let openTitle = "Open Threads";
    let openTitleRow = worksheet.addRow([openTitle]);
    openTitleRow.font = { name: 'Comic Sans MS', family: 4, size: 12, bold: true }
    worksheet.addRow([]);
    let openHeaderRow = worksheet.addRow(openHeader);

    // Cell Style : Fill and Border
    openHeaderRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'e8e3e3' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    });

    // Add Data and Conditional Formatting
    openData.forEach(ot => {
      let row = worksheet.addRow(ot);
    });
    
    // Closed Threads Data
    
    //Blank Row 
    worksheet.addRow([]);
    worksheet.addRow([]);

    // Add Header Row
    let closedTitle = "Closed Threads";
    let closedTitleRow = worksheet.addRow([closedTitle]);
    closedTitleRow.font = { name: 'Comic Sans MS', family: 4, size: 12, bold: true }
    worksheet.addRow([]);
    let closedHeaderRow = worksheet.addRow(closedHeader);

    // Cell Style : Fill and Border
    closedHeaderRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'e8e3e3' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    });

    // Add Data and Conditional Formatting
    closedData.forEach(ct => {
      let row = worksheet.addRow(ct);
    });
    

    // Thread Lists Data
    
    //Blank Row 
    worksheet.addRow([]);
    worksheet.addRow([]);

    // Add Header Row
    let threadListTitle = threadTitle+" Thread Lists";
    let threadListTitleRow = worksheet.addRow([threadListTitle]);
    threadListTitleRow.font = { name: 'Comic Sans MS', family: 4, size: 12, bold: true }
    worksheet.addRow([]);
    let threadListHeaderRow = worksheet.addRow(threadListHeader);

    // Cell Style : Fill and Border
    threadListHeaderRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'e8e3e3' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    });

    // Add Data and Conditional Formatting
    let t2=0;
    this.threadLists.forEach(tl => {
      t2=t2+1;
      let row = worksheet.addRow(tl);
      worksheet.getColumn(t2).width = 30;
      if(threadTitle == 'Open') {
        let ts = row.getCell(18);
        ts.alignment = {
          horizontal: 'left'
        }  
      } else {
        let ts = row.getCell(19);
        ts.alignment = {
          horizontal: 'left'
        }

        let tc = row.getCell(20);
        tc.alignment = {
          horizontal: 'left'
        }
      }
    });
    
    worksheet.addRow([]);
    if(this.exceldownloadtrue)
    {
      this.progressbarCount='100';
      this.progressbarCountWidth=this.progressbarCount+'%';
      this.downloadtextflag='Processing Excel';
      
      setTimeout(() => {
    //Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'Thread_Reports_'+this.currDateTime+'.xlsx');
    });  
    this.exceldownloadtrue=false; 
    this.stopexportapi=true;
    this.itemOffset=0;
    this.threadLists=[];
    this.progressbarCount='0';
    this.progressbarCountWidth=this.progressbarCount+'%';
    this.downloadtextflag='Adding data to Excel sheet';
    this.updateonExportisDone.emit(1);
  },3000);
  }
  else
  {
    if(this.exportAllFlag)
    {
      this. getexceldata();
    }
    else
    {
      this.getexceldataThread();
    }
    
   
  } 

  }

  exportThreadReportsOld(title, exportData) {
    let openThreadsData = exportData.openThreads;
    let closedThreadsData = exportData.closedThreads;
    let threadListData = exportData.threadList;

    let openHeader = ['Thread Status', 'Total Count', 'Percentage'];
    let openData = [];
    for (let openThread in openThreadsData) {
      let status = openThreadsData[openThread].title;
      let count = openThreadsData[openThread].countValue;
      let percentVal = openThreadsData[openThread].percentageValue + '%';
      let openThreadInfo = [status, count, percentVal];
      openData.push(openThreadInfo);
    }

    let closedHeader = ['Thread Status', 'Total Count', 'Percentage'];
    let closedData = [];
    for (let closedThread in closedThreadsData) {
      let status = closedThreadsData[closedThread].title;
      let count = closedThreadsData[closedThread].countValue;
      let percentVal = closedThreadsData[closedThread].percentageValue + '%';
      let closedThreadInfo = [status, count, percentVal];
      closedData.push(closedThreadInfo);
    }

    let threadTitle = title[1].charAt(0).toUpperCase() + title[1].slice(1);
    let threadListHeader;
    let startDateExcel = '';
    if (this.isCollabtic) {
      threadListHeader = ['Thread Created by', 'Assigned To','Category', 'Make > Model > Year', 'Title', 'Open Date', 'Fix Date', 'Time to Fix (Hrs)','First Response Date','First Response (Hrs)','Thread Closed Date','Time to Close', 'Thread Status', 'Thread ID' , 'WorkOrder'];
      if (this.apiData.hasOwnProperty('filterOptions')) {
        if (this.apiData.filterOptions.hasOwnProperty('startDate') && this.apiData.filterOptions.hasOwnProperty('endDate')) {
          startDateExcel = ' for ' + moment(this.apiData.filterOptions.startDate).format('YYYY-MM-DD') + ' - ' +
            moment(this.apiData.filterOptions.endDate).format('YYYY-MM-DD');
        } else {
          startDateExcel = ' for ' + moment().subtract(30, 'days').format('MMM D, YYYY') + ' - ' +
            moment().format('MMM D, YYYY');
        }
      }
    } else {
      if (threadTitle == 'Open') {
        threadListHeader = ['Dealer Name', 'ID', 'User Type', 'Zone', 'Area', 'TTY', 'Product Owner', 'TM Name', 'Thread Creation Date/Time', 'Model > Year', 'Frame#', 'Odo Meter', 'Title', 'Error Code', 'Description', 'Status', 'Esc Level', 'Proposed Fix Date', 'Proposed Fix Content', '1st Reply Time', 'Thread ID', 'Time to Share Proposed Fix (Hrs)', 'Open/Closed', 'Workstreams', 'Feedback Status'];
      } else {
        threadListHeader = ['Dealer Name', 'ID', 'User Type', 'Zone', 'Area', 'TTY', 'Product Owner', 'TM Name', 'Thread Creation Date/Time', 'Model > Year', 'Frame#', 'Odo Meter', 'Title', 'Error Code', 'Description', 'Status', 'Esc Level', 'Proposed Fix Date', 'Proposed Fix Content', '1st Reply Time', 'Thread ID', 'Thread Closed Date', 'Time to Time to Share Proposed Fix (Hrs)', 'Time to Close (Hrs)', 'Open/Closed', 'Workstreams', 'Feedback Status'];
      }
    }
    //console.log(threadListData)
    for (let threadList in threadListData) {
      //console.log(threadListData[threadList].thread_id)
      let threadOwner = (this.isCollabtic) ? threadListData[threadList].threadOwner : '';
      let dealerName = threadListData[threadList].dealerName;
      dealerName = (this.isCollabtic) ? threadOwner : dealerName;
      let dealerCode = threadListData[threadList].dealerCode;
      let userTypeName = threadListData[threadList].userTypeName;
      let zone = threadListData[threadList].zone;
      let userarea = threadListData[threadList].userarea;
      let tty = threadListData[threadList].territory;
      let prodOwner = (this.isCollabtic) ? threadListData[threadList].assignedUser : threadListData[threadList].assignedUser;
      let tmName = threadListData[threadList].territory_manager;
      let threadCreation = threadListData[threadList].created_on;
      let make = threadListData[threadList].make ? threadListData[threadList].make + ' > ' : '';
      let category = threadListData[threadList].threadCategoryStr ? threadListData[threadList].threadCategoryStr: '-';
      threadListData[threadList].year = threadListData[threadList].year && threadListData[threadList].year != 0 ? threadListData[threadList].year : '';
      let model = (threadListData[threadList].year) ? threadListData[threadList].model + ' > ' + threadListData[threadList].year : threadListData[threadList].model;
      let frame = threadListData[threadList].frameNo;
      let odoMeter = threadListData[threadList].odoMeter;
      let title = threadListData[threadList].title;
      let errorCode = threadListData[threadList].error_code;
      let desc = threadListData[threadList].description;
      let threadStatus = threadListData[threadList].thread_status;
      let escLevel = threadListData[threadList].escalate_status_land;
      let proposedFixDate = threadListData[threadList].proposedFix_createdOn;
      let firstTimeReply = threadListData[threadList].firstReplyFromEmp;
      //added by karuna for proposed fix content
      let proposedFix_content = threadListData[threadList].proposedFix_contentxls;
      let threadId = '#' + threadListData[threadList].thread_id;
      let timeToRespond = (threadListData[threadList].exportTimeToRespond == '-' || threadListData[threadList].exportTimeToRespond == '') ? 0 : threadListData[threadList].exportTimeToRespond;
      let threadFixDate = threadListData[threadList].threadFixDate;
      let timeToFix = (threadListData[threadList].timeToFix == '-' || threadListData[threadList].timeToFix == '') ? '-' : threadListData[threadList].timeToFix;

      let firstReplyFromEmp = (threadListData[threadList].firstReplyFromEmp == '-' || threadListData[threadList].firstReplyFromEmp == '') ? '-' : threadListData[threadList].firstReplyFromEmp;

      let firstReplyTime = (threadListData[threadList].firstReplyTime == '-' || threadListData[threadList].firstReplyTime == '') ? '-' : threadListData[threadList].firstReplyTime;

      let timeToCloseData = (threadListData[threadList].timeToClose == '-' || threadListData[threadList].timeToClose == '') ? '-' : threadListData[threadList].timeToClose;

      let close_dateData = (threadListData[threadList].close_date == '-' || threadListData[threadList].close_date == '') ? '-' : threadListData[threadList].close_date;
      let timeclose_status = threadListData[threadList].close_status;
      let workstreamsListthread = threadListData[threadList].workstreamsList;
      let feedbackStatus = threadListData[threadList].feedbackStatus;
      let workOrder = (this.isCollabtic) ? threadListData[threadList].workOrder : '' ;
      console.log(workOrder);

      let timeToClose: any = 0;
      let openclosestatus = '';
      if (timeclose_status == 1) {
        openclosestatus = 'Closed';
      } else {
        openclosestatus = 'Open';
      }

      let threadListInfo;
      if (this.isCollabtic) {
        threadListInfo = [
          dealerName,
          prodOwner,
          category,
          make+model,
          title,
          threadCreation,
          threadFixDate,
          timeToFix,
          firstReplyFromEmp,
          firstReplyTime,
          close_dateData,
          timeToCloseData,
         threadStatus,
          threadId,
          workOrder
        ];
      } else {
        if (threadTitle == 'Open') {
          threadListInfo = [dealerName, dealerCode, userTypeName, zone, userarea, tty, prodOwner, tmName, threadCreation, model, frame, odoMeter, title, errorCode, desc, threadStatus, escLevel, proposedFixDate, proposedFix_content, firstTimeReply, threadId, timeToRespond, openclosestatus, workstreamsListthread, feedbackStatus];
        } else {
          let threadCloseDate = threadListData[threadList].close_date;
          timeToClose = (threadListData[threadList].exportTimeToClose == '-' || threadListData[threadList].exportTimeToClose == '') ? 0 : threadListData[threadList].exportTimeToClose;
          threadListInfo = [dealerName, dealerCode, userTypeName, zone, userarea, tty, prodOwner, tmName, threadCreation, model, frame, odoMeter, title, errorCode, desc, threadStatus, escLevel, proposedFixDate, proposedFix_content, firstTimeReply, threadId, threadCloseDate, timeToRespond, timeToClose, openclosestatus, workstreamsListthread, feedbackStatus];
        }
      }
      this.threadLists.push(threadListInfo);
    }

    //Create workbook and worksheet
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet(title[0]);

    //Add Row and formatting
    let titleRow = worksheet.addRow([title[0]]);
    titleRow.font = { name: 'Comic Sans MS', family: 4, size: 16, bold: true }
    worksheet.addRow([]);
    //let subTitleRow = worksheet.addRow(['Date : ' + this.datePipe.transform(new Date(), 'medium')]);

    // Open Threads Data

    //Blank Row
    worksheet.addRow([]);
    // Add Header Row
    let openTitle = "Open Threads" + startDateExcel;
    let openTitleRow = worksheet.addRow([openTitle]);
    openTitleRow.font = { name: 'Comic Sans MS', family: 4, size: 12, bold: true }
    worksheet.addRow([]);
    let openHeaderRow = worksheet.addRow(openHeader);

    // Cell Style : Fill and Border
    openHeaderRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'e8e3e3' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    });

    // Add Data and Conditional Formatting
    openData.forEach(ot => {
      let row = worksheet.addRow(ot);
    });

    // Closed Threads Data

    //Blank Row
    worksheet.addRow([]);
    worksheet.addRow([]);

    // Add Header Row
    let closedTitle = "Closed Threads" + startDateExcel;
    let closedTitleRow = worksheet.addRow([closedTitle]);
    closedTitleRow.font = { name: 'Comic Sans MS', family: 4, size: 12, bold: true }
    worksheet.addRow([]);
    let closedHeaderRow = worksheet.addRow(closedHeader);

    // Cell Style : Fill and Border
    closedHeaderRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'e8e3e3' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    });

    // Add Data and Conditional Formatting
    closedData.forEach(ct => {
      let row = worksheet.addRow(ct);
    });


    // Thread Lists Data

    //Blank Row
    worksheet.addRow([]);
    worksheet.addRow([]);

    // Add Header Row
    let threadListTitle = threadTitle + " Thread Lists";
    let threadListTitleRow = worksheet.addRow([threadListTitle]);
    threadListTitleRow.font = { name: 'Comic Sans MS', family: 4, size: 12, bold: true }
    worksheet.addRow([]);
    let threadListHeaderRow = worksheet.addRow(threadListHeader);

    // Cell Style : Fill and Border
    threadListHeaderRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'e8e3e3' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    });

    // Add Data and Conditional Formatting
    let t2 = 0;
    this.threadLists.forEach(tl => {
      t2 = t2 + 1;
      let row = worksheet.addRow(tl);
      worksheet.getColumn(t2).width = 30;
      if (threadTitle == 'Open') {
        let ts = row.getCell(18);
        ts.alignment = {
          horizontal: 'left'
        }
      } else {
        let ts = row.getCell(19);
        ts.alignment = {
          horizontal: 'left'
        }

        let tc = row.getCell(20);
        tc.alignment = {
          horizontal: 'left'
        }
      }
    });

    worksheet.addRow([]);
    if (this.exceldownloadtrue) {
      this.progressbarCount = '100';
      this.progressbarCountWidth = this.progressbarCount + '%';
      this.downloadtextflag = 'Processing Excel';

      setTimeout(() => {
        //Generate Excel File with given name
        workbook.xlsx.writeBuffer().then((data) => {
          let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          fs.saveAs(blob, 'Thread_Reports.xlsx');
        });
        this.exceldownloadtrue = false;
        this.stopexportapi = true;
        this.itemOffset = 0;
        this.threadLists = [];
        this.progressbarCount = '0';
        this.progressbarCountWidth = this.progressbarCount + '%';
        this.downloadtextflag = 'Adding data to Excel sheet';
        this.updateonExportisDone.emit(1);
      }, 3000);
    }
    else {
      if (this.exportAllFlag) {
        this.getexceldata();
      }
      else {
        this.getexceldataThread();
      }
    }
  }

  getUserDashboard(){
    console.log(this.apiData)
    this.apiData['limit'] = this.itemLimit;
    this.apiData['offset'] = this.itemOffset;

    const apiFormData = new FormData();
    apiFormData.append("apiKey", this.apiData["apiKey"]);
    apiFormData.append("domainId", this.apiData["domainId"]);
    apiFormData.append("countryId", this.apiData["countryId"]);
    apiFormData.append("userId", this.apiData["userId"]);
    //apiFormData.append("searchKey", this.apiData["searchKey"]);
    apiFormData.append("limit", this.apiData["limit"]);
    apiFormData.append("offset", this.apiData["offset"]);
    apiFormData.append("userType",this.apiData["userType"]);
    apiFormData.append("userExport",'1');

    this.uploadFlag =  this.userDashboardApi.getuserlist(apiFormData).subscribe((response) => {
      let exportData = response.data.user_details;
      let total_count = response.data.totalCount;
      //this.totalLimit = 10;
      this.totalLimit = total_count;
      this.itemLength += total_count;
      this.itemOffset += this.itemLimit;
      //console.log(this.itemOffset/total_count)
      this.progressbarCount = ((this.itemOffset / total_count) * 100).toFixed(0);
      this.progressbarCountWidth = this.progressbarCount + '%';
      if (total_count == 0) {
      }
      else {
        if (this.stopexportapi) {
          if (this.itemOffset >= this.totalLimit) {
            this.exceldownloadtrue = true;;
          }
          this.generateExcel(this.access, '', exportData,this.apiData["domainId"], this.apiData["exportHeader"],this.apiData['userTypeName'],this.apiData['workstreamArr']);
        }
        if (this.itemOffset >= this.totalLimit) {
          this.stopexportapi = false;
        }
      }
    });
  }
   // Export DTC Data
   getGTSExcelData() {
    //console.log(this.apiData)
    this.apiData['limit'] = this.itemLimit;
    this.apiData['offset'] = this.itemOffset;

    const apiFormData = new FormData();
    apiFormData.append("apiKey", this.apiData["apiKey"]);
    apiFormData.append("domainId", this.apiData["domainId"]);
    apiFormData.append("countryId", this.apiData["countryId"]);
    apiFormData.append("userId", this.apiData["userId"]);
    apiFormData.append("searchKey", this.apiData["searchKey"]);
    apiFormData.append("limit", this.apiData["limit"]);
    apiFormData.append("offset", this.apiData["offset"]);
    apiFormData.append("filterOptions",JSON.stringify(this.apiData["filterOptions"]));

    this.uploadFlag =  this.gtsListingApi.getGTSLists(apiFormData).subscribe((response) => {
      let exportData = response.procedure;
      let total_count = response.total;
      this.totalLimit = total_count;
      this.itemLength += total_count;
      this.itemOffset += this.itemLimit;
      //console.log(this.itemOffset/total_count)
      this.progressbarCount = ((this.itemOffset / total_count) * 100).toFixed(0);
      this.progressbarCountWidth = this.progressbarCount + '%';
      if (total_count == 0) {
      }
      else {
        if (this.stopexportapi) {
          if (this.itemOffset >= this.totalLimit) {
            this.exceldownloadtrue = true;;
          }
          this.generateExcel(this.access, this.exportInfo, exportData);
        }
        if (this.itemOffset >= this.totalLimit) {
          this.stopexportapi = false;
        }
      }
    });
  }

  // Export DTC Data
  getDTCExcelData() {
    console.log(this.apiData)
    this.apiData['limit'] = this.itemLimit;
    this.apiData['offset'] = this.itemOffset;
    this.uploadFlag = this.commonService.getErrorCodes(this.apiData).subscribe((response) => {
      let exportData = response.errorCodes;
      let total_count = response.total;
      this.totalLimit = total_count;
      this.itemLength += total_count;
      this.itemOffset += this.itemLimit;
      console.log(this.itemOffset/total_count)
      this.progressbarCount = ((this.itemOffset / total_count) * 100).toFixed(0);
      this.progressbarCountWidth = this.progressbarCount + '%';
      if (total_count == 0) {
      }
      else {
        if (this.stopexportapi) {
          if (this.itemOffset >= this.totalLimit) {
            this.exceldownloadtrue = true;;
          }
          this.generateExcel(this.access, this.exportInfo, exportData);
        }
        if (this.itemOffset >= this.totalLimit) {
          this.stopexportapi = false;
        }
      }
    });
  }

  exportDTCReport(access, title, exportData) {
    let apiData = exportData;
    let headers = ['S.No', 'Code', 'Description'];
    apiData.forEach(data => {
      this.sNo = this.sNo + 1;
      let dtcInfo = [this.sNo, data.code, data.desc];
      this.dtcInfo.push(dtcInfo)
    });

    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet(title);
    let headerRow = worksheet.addRow(headers);

    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'e8e3e3' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' } }
    });

    this.dtcInfo.forEach(l => {
      let row = worksheet.addRow(l);
      let qty = row.getCell(3);
      let color = 'FFFFFF';
      if (+qty.value < 500) {
        color = 'FF9999'
      }
      qty.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: color }
      }
    });

    worksheet.getColumn(1).width = 10;
    worksheet.getColumn(2).width = 30;
    worksheet.getColumn(3).width = 30;
    worksheet.addRow([]);

    if (this.exceldownloadtrue) {
      this.progressbarCount = '100';
      this.progressbarCountWidth = this.progressbarCount + '%';
      this.downloadtextflag = 'Export complete.';
      let date = '';
      if (this.apiData.hasOwnProperty('uploadedOn')) {
        let uploadedDate = this.apiData.uploadedOn;
        date = (uploadedDate == '-') ? date : moment(uploadedDate).format('MMM DD, YYYY');
      }
      let fname = (access == 'dtc') ? 'DTC' : 'DTC Template';
      let fileName = (access == 'dtc') ? `${title} ${fname} ${date}.xlsx` : `${fname}.xlsx`;
      setTimeout(() => {
        //Generate Excel File with given name
        workbook.xlsx.writeBuffer().then((data) => {
          let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          fs.saveAs(blob, fileName);
        });
        this.exceldownloadtrue = false;
        this.stopexportapi = true;
        this.itemOffset = 0;
        this.progressbarCount = '0';
        this.progressbarCountWidth = this.progressbarCount + '%';
        this.downloadtextflag = 'Exporting data to Excel..';
        this.updateonExportisDone.emit(1);
      }, 3000);
    } else {
      this.getDTCExcelData();
    }
  }

  exportGTSReport(access, title, exportData) {
    //console.log(exportData)
    let apiData = exportData;
    let platformId = localStorage.getItem('platformId');
    let tvsFlag = (platformId == '2' && this.apiData["domainId"] == 52) ? true : false;

    let headers = [];
    if(tvsFlag){
      headers = ['Problem Category', 'GTS Procedure Title', 'Module Type', 'Module Mfg','DTC', 'DTC Description', 'System', 'Procedure ID', 'Workstream Name', 'Product Type','Model', 'Year','Created On','Created By','Modified On','Modified By','Status'];
    }
    else{
      headers = ['Problem Category', 'GTS Procedure Title', 'System', 'Procedure ID', 'Workstream Name', 'Make','Model', 'Year','Created On','Created By','Modified On','Modified By','Status'];
    }

    apiData.forEach(data => {
      let diagnosticInfo: any = [];
      let infoItems = data.procedureId;
      if(infoItems.length == 0) {
        diagnosticInfo = [''];
        this.diagnosticInfo.push(diagnosticInfo);
      } else {

        let vehicleInfo: any;
        let vehicleFlag: boolean;
        let make = [];
        let makeStr = "";
        let model = [];
        let modelStr = "";
        let year = [];
        let yearStr = "";
        vehicleInfo = data.vehicleDetails == "" ? data.vehicleDetails : JSON.parse(data.vehicleDetails);
        vehicleFlag = vehicleInfo.length == 0 ? false : true;
        //console.log(vehicleInfo);
        if (vehicleFlag) {
          for (let vh of vehicleInfo) {
            year = vh.year == 0 && vh.year != '' ? ['All'] : vh.year;
            //console.log(year);
            make.push(vh.productType);
            model.push(vh.model);
            year.push(year);
          }
        }
        //console.log(year);
        makeStr = make.toString();
        modelStr = model.toString();
        yearStr = year.toString();
        if(yearStr!=''){
          yearStr = yearStr.replace(/,\s*$/, "");
        }

        let gtsid = data.procedureId.toString();
        //console.log(gtsid);
        //console.log(data.workstreamsList);
        //console.log(makeStr);
        //console.log(modelStr);
        console.log(yearStr);
        let createdDate = moment.utc(data.createdOn).toDate();
        let localCreatedDate = moment(createdDate).local().format("MMM DD, YYYY h:mm A");
        let updatedDate = data.updatedOn == '' ? '' : moment.utc(data.updatedOn).toDate();
        let localUpdatedDate;
        if(updatedDate != ''){
          localUpdatedDate = moment(updatedDate).local().format("MMM DD, YYYY h:mm A");
        }
        if(tvsFlag){
          diagnosticInfo = [data.productCategoryName, data.name, data.productModuleType, data.productModuleMfg, data.dtcCode, data.dtcDesc, data.systemSelection, gtsid, data.workstreamsList, makeStr, modelStr, yearStr, localCreatedDate, data.createdBy, localUpdatedDate, data.updatedBy, data.status ];
        }
        else{
          diagnosticInfo = [data.productCategoryName, data.name, data.systemSelection, gtsid, data.workstreamsList, makeStr, modelStr, yearStr, localCreatedDate, data.createdBy, localUpdatedDate, data.updatedBy, data.status ];
        }
        this.diagnosticInfo.push(diagnosticInfo);
        //console.log(this.diagnosticInfo);
      }
    });

    let workbook = new Workbook();
    title = 'GTS Procedure';

    let worksheet = workbook.addWorksheet(title);

    let titleRow = worksheet.addRow([title]);
    titleRow.font = { name: 'Calibri', family: 4, size: 16, bold: true }
    worksheet.addRow([]);

    let headerRow = worksheet.addRow(headers);

    headerRow.font = { name: 'Calibri', family: 4, size: 11, bold: true }
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'e8e3e3' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' } }
    });



    this.diagnosticInfo.forEach(l => {
      let row = worksheet.addRow(l);
      let qty = row.getCell(100);
      let color = 'FFFFFF';
      if (+qty.value < 500) {
        color = 'FFFFFF'
      }
      qty.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: color }
      }
    });

    if(tvsFlag){
      worksheet.getColumn(1).width = 30;
      worksheet.getColumn(2).width = 45;
      worksheet.getColumn(3).width = 20;
      worksheet.getColumn(4).width = 20;
      worksheet.getColumn(5).width = 20;
      worksheet.getColumn(6).width = 35;
      worksheet.getColumn(7).width = 20;
      worksheet.getColumn(8).width = 20;
      worksheet.getColumn(9).width = 35;
      worksheet.getColumn(10).width = 30;
      worksheet.getColumn(11).width = 30;
      worksheet.getColumn(12).width = 20;
      worksheet.getColumn(13).width = 35;
      worksheet.getColumn(14).width = 20;
      worksheet.getColumn(15).width = 35;
      worksheet.getColumn(16).width = 20;
      worksheet.getColumn(17).width = 20;
    }
    else{
      worksheet.getColumn(1).width = 30;
      worksheet.getColumn(2).width = 35;
      worksheet.getColumn(3).width = 30;
      worksheet.getColumn(4).width = 20;
      worksheet.getColumn(5).width = 35;
      worksheet.getColumn(6).width = 35;
      worksheet.getColumn(7).width = 35;
      worksheet.getColumn(8).width = 35;
      worksheet.getColumn(9).width = 35;
      worksheet.getColumn(10).width = 30;
      worksheet.getColumn(11).width = 35;
      worksheet.getColumn(12).width = 30;
      worksheet.getColumn(13).width = 20;
    }



    worksheet.addRow([]);

    if (this.exceldownloadtrue) {
      this.progressbarCount = '100';
      this.progressbarCountWidth = this.progressbarCount + '%';
      this.downloadtextflag = 'Export complete.';
      let date = '';
      if (this.apiData.hasOwnProperty('uploadedOn')) {
        let uploadedDate = this.apiData.uploadedOn;
        date = (uploadedDate == '-') ? date : moment(uploadedDate).format('MMM DD, YYYY');
      }
      let fname = 'gts';
      let fileName = `${fname}.xlsx`;
      setTimeout(() => {
        //Generate Excel File with given name
        workbook.xlsx.writeBuffer().then((data) => {
          let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          fs.saveAs(blob, fileName);
        });
        this.exceldownloadtrue = false;
        this.stopexportapi = true;
        this.itemOffset = 0;
        this.progressbarCount = '0';
        this.progressbarCountWidth = this.progressbarCount + '%';
        this.downloadtextflag = 'Exporting data to Excel..';
        this.updateonExportisDone.emit(1);
      }, 3000);
    } else {
      this.getGTSExcelData();
    }
  }

  exportUserDashboardReport(access, title, exportData,domainId,exportHeader,threadListHeader1,workstreamdIds) {

    console.log(exportData,domainId,exportHeader,threadListHeader1,workstreamdIds);

    let userListData = exportData;
    let threadListHeader;
   // threadListHeader = ['Dealer Name', 'ID', 'User Type', 'Zone', 'Area', 'TTY', 'Product Owner', 'TM Name', 'Thread Creation Date/Time', 'Model > Year', 'Title', 'Error Code', 'Status', 'Esc Level', 'Proposed Fix Date', 'Proposed Fix Content', 'Thread ID', 'Time to Respond','Open/Closed','Workstreams']
   threadListHeader=exportHeader;
   //let userDashLists = [];
   for (let userList in userListData) {
    let ULoginID = userListData[userList].LoginID;
    let UFirstName = userListData[userList].FirstName;
    let ULastName = userListData[userList].LastName;
    let UEmailAddress = userListData[userList].EmailAddress;
    let UIsVerified= userListData[userList].IsVerified;

    let UuserRole = userListData[userList].userRole;
    let UbusinessRole = userListData[userList].businessRole;
    let UassigneeRole = userListData[userList].assigneeRole;
    let businessName = userListData[userList].bussName;

    let Uisactive = userListData[userList].isactive;
    let locallastupdatedDate='';
    
    if(userListData[userList].last_updated_on)
    {
      locallastupdatedDate= moment(moment.utc(userListData[userList].last_updated_on).toDate()).local().format('MMM DD, YYYY . h:mm A');
    }
    else
    {
      locallastupdatedDate='';
    }
    
    let UbussTitle = userListData[userList].bussTitle;
    let UUsername = userListData[userList].Username;
    let Ucreated_on = userListData[userList].created_on;
    let UManagerName = userListData[userList].ManagerName;
    let dealerCode=userListData[userList].dealerCode;
    let dealerName=userListData[userList].dealerName;
    let contactPersonEmail=userListData[userList].contactPersonEmail;
    let contactPersonPhone=userListData[userList].contactPersonPhone;
    let contactPersonName=userListData[userList].contactPersonName;
    let ccity=userListData[userList].city;
    let cstate=userListData[userList].state;    
    let czone=userListData[userList].zone;
    let cuserarea=userListData[userList].userarea;
    let cterritory=userListData[userList].territory;

    let waitingforApproval=userListData[userList].waitingforApproval;
    
    
    let wst=[];
    let userListInfo;
   if(domainId=='52')
   {

    if(this.apiData["userType"] == '1' || this.apiData["userType"] == '3'){
      userListInfo = [ULoginID,UFirstName,ULastName,locallastupdatedDate,UbussTitle,UbusinessRole,UassigneeRole,UUsername,Ucreated_on,UManagerName,UEmailAddress,czone,UIsVerified,UuserRole,Uisactive,waitingforApproval];
    }
    else if(this.apiData["userType"] == '2'){
     userListInfo = [ULoginID,dealerName,dealerCode,locallastupdatedDate,UbussTitle,UbusinessRole,UassigneeRole,UUsername,Ucreated_on,UManagerName,ccity,cstate,czone,cuserarea,cterritory,UEmailAddress,UIsVerified,UuserRole,Uisactive,waitingforApproval];
    }
    else if(this.apiData["userType"] == '6'){

        let EMPLOYEE_ID=userListData[userList].EMPLOYEE_ID;
        let EMP_SUBGRP_ID=userListData[userList].EMP_SUBGRP_ID;
        let EMP_BRANCH_ID=userListData[userList].EMP_BRANCH_ID;
        let branchName=userListData[userList].branchName;
        let DATE_OF_BIRTH='';
        if(userListData[userList].DATE_OF_BIRTH){
          let date1 = moment.utc(userListData[userList].DATE_OF_BIRTH).toDate();
          DATE_OF_BIRTH = moment(date1).local().format('MMM DD, YYYY . h:mm A');
        }
        let JOIN_DATE='';
        if(userListData[userList].JOIN_DATE){
        let date2 = moment.utc(userListData[userList].JOIN_DATE).toDate();
        JOIN_DATE = moment(date2).local().format('MMM DD, YYYY . h:mm A');
        }
        let LEAVE_DATE=userListData[userList].LEAVE_DATE;
        let ADDRESS_LINE_1=userListData[userList].ADDRESS_LINE_1;
        let ADDRESS_LINE_2=userListData[userList].ADDRESS_LINE_2;
        let ADDRESS_LINE_3=userListData[userList].ADDRESS_LINE_3;
        let LANDMARK=userListData[userList].LANDMARK;
        let CITY=userListData[userList].CITY;
        let STATE_ID=userListData[userList].STATE_ID;
        let PIN_CODE=userListData[userList].PIN_CODE;
        let PERM_PHONE_NO=userListData[userList].PERM_PHONE_NO;
        let LOC_ADDRESS=userListData[userList].LOC_ADDRESS;
        let LOCAL_PHONE_NO=userListData[userList].LOCAL_PHONE_NO;
        let EMAIL_ID=userListData[userList].EMAIL_ID;
        let PAN_NO=userListData[userList].PAN_NO;
        
        let CREATED_ON='';
        if(userListData[userList].CREATED_ON){
          let date3 = moment.utc(userListData[userList].CREATED_ON).toDate();
          CREATED_ON = moment(date3).local().format('MMM DD, YYYY . h:mm A');
        }

        let MODIFIED_ON='';
        if(userListData[userList].MODIFIED_ON){
          let date4 = moment.utc(userListData[userList].MODIFIED_ON).toDate();
          MODIFIED_ON = moment(date4).local().format('MMM DD, YYYY . h:mm A');
        }
        let GENDER=userListData[userList].GENDER;
        let SON_DAU_OF=userListData[userList].SON_DAU_OF;
        let MARRIED=userListData[userList].MARRIED;
        let WORK_EXP_YRS=userListData[userList].WORK_EXP_YRS; 
        let WORK_EXP_MONTHS=userListData[userList].WORK_EXP_MONTHS;
        let WORK_EXP_COMPANY=userListData[userList].WORK_EXP_COMPANY;
        let IS_DRIVING_LICENSE=userListData[userList].IS_DRIVING_LICENSE;
        let DL_NO=userListData[userList].DL_NO;
        //let DL_EXPIRY_DATE=userListData[userList].DL_EXPIRY_DATE;
        let DL_EXPIRY_DATE='';
        if(userListData[userList].DL_EXPIRY_DATE){
          let date5 = moment.utc(userListData[userList].DL_EXPIRY_DATE).toDate();
          DL_EXPIRY_DATE = moment(date5).local().format('MMM DD, YYYY . h:mm A');
        }
        let COMP_KNOWLEDGE_MS_OFFICE=userListData[userList].COMP_KNOWLEDGE_MS_OFFICE;
        let COMP_KNOWLEDGE_PROGRAMMING_LANGUAGE=userListData[userList].COMP_KNOWLEDGE_PROGRAMMING_LANGUAGE; 
        let COMP_KNOWLDGE_OTHERS=userListData[userList].COMP_KNOWLDGE_OTHERS;
        let EMP_EDU_ID=userListData[userList].EMP_EDU_ID;
        let EDUCATION=userListData[userList].EDUCATION;
        let EMPLOYEE_AADHAR_NO=userListData[userList].EMPLOYEE_AADHAR_NO;
        let SUBGROUP_DESC=userListData[userList].SUBGROUP_DESC;
        let GROUP_DESC=userListData[userList].GROUP_DESC;    
        
        userListInfo = [ULoginID, UUsername,dealerName,dealerCode,SUBGROUP_DESC,GROUP_DESC,
        locallastupdatedDate, UbussTitle, UbusinessRole,UassigneeRole,Ucreated_on,
        UManagerName,UIsVerified,UuserRole,waitingforApproval,EMPLOYEE_ID,EMP_SUBGRP_ID,
        EMP_BRANCH_ID,branchName,DATE_OF_BIRTH,JOIN_DATE,LEAVE_DATE,ADDRESS_LINE_1,
        ADDRESS_LINE_2,ADDRESS_LINE_3,LANDMARK,CITY,STATE_ID,PIN_CODE,PERM_PHONE_NO,
        LOC_ADDRESS,LOCAL_PHONE_NO,UEmailAddress,PAN_NO,CREATED_ON, MODIFIED_ON, Uisactive,
        GENDER, SON_DAU_OF, MARRIED, WORK_EXP_YRS, WORK_EXP_MONTHS, WORK_EXP_COMPANY,
        IS_DRIVING_LICENSE, DL_NO, DL_EXPIRY_DATE, COMP_KNOWLEDGE_MS_OFFICE, COMP_KNOWLEDGE_PROGRAMMING_LANGUAGE, 
        COMP_KNOWLDGE_OTHERS, EMP_EDU_ID, EDUCATION, EMPLOYEE_AADHAR_NO];
    }
    else{
      userListInfo = [ULoginID,UFirstName,ULastName,locallastupdatedDate,UbussTitle,UbusinessRole,UassigneeRole,UUsername,Ucreated_on,UManagerName,UEmailAddress,UIsVerified,UuserRole,Uisactive,waitingforApproval];
    }
  }
   else if(domainId=='97')
   {
    userListInfo = [ULoginID,UFirstName,ULastName,UEmailAddress,UIsVerified,UuserRole,Uisactive,locallastupdatedDate,UbussTitle,UbusinessRole,UUsername,Ucreated_on,UManagerName,dealerCode,dealerName,czone,cuserarea,contactPersonEmail,contactPersonPhone,contactPersonName];
   }
   else
   {
    userListInfo = [ULoginID,UFirstName,ULastName,UEmailAddress,UIsVerified,UuserRole,Uisactive,locallastupdatedDate,businessName,UbussTitle,UbusinessRole,UUsername,Ucreated_on,UManagerName];
   }

    for(let ws=0;ws<workstreamdIds.length;ws++)
    {
      let wnamearr='"'+userListData[userList][workstreamdIds[ws]]+'"';
      console.log(userListData[userList][workstreamdIds[ws]]);
      userListInfo.push(userListData[userList][workstreamdIds[ws]]);


    }

    //return false;
    //let joinuser=wst.join(',');
    //console.log(joinuser);

    //return false;



console.log(userListInfo);

      this.userDashLists.push(userListInfo);
     // return false;
   }
   title = threadListHeader1+"_"+"User_Dashboard";
   let workbook = new Workbook();
    let worksheet = workbook.addWorksheet(title);





    // Add Header Row
   let titleInfo = threadListHeader1+" "+"User Dashboard Reports";
    let openTitleRow = worksheet.addRow([titleInfo]);
    openTitleRow.font = { name: 'Comic Sans MS', family: 4, size: 12, bold: true }
    worksheet.addRow([]);


    let threadListHeaderRow = worksheet.addRow(threadListHeader);

    // Cell Style : Fill and Border
    threadListHeaderRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'e8e3e3' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    });


    let t2=0;
    this.userDashLists.forEach(tl => {
      t2=t2+1;
      worksheet.addRow(tl);
    });

    threadListHeader.forEach((item, index) => {
      let width = 30;
      worksheet.getColumn(index+1).width = width;
    })



    worksheet.addRow([]);
    worksheet.addRow([]);
/*
    //Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'User_dashboard.xlsx');
    });
	*/


	 if (this.exceldownloadtrue) {
      this.progressbarCount = '100';
      this.progressbarCountWidth = this.progressbarCount + '%';
      this.downloadtextflag = 'Export complete.';
      let date = '';
      if (this.apiData.hasOwnProperty('uploadedOn')) {
        let uploadedDate = this.apiData.uploadedOn;
        date = (uploadedDate == '-') ? date : moment(uploadedDate).format('MMM DD, YYYY');
      }

      let fileName = `${title}.xlsx`;
      setTimeout(() => {
        //Generate Excel File with given name
        workbook.xlsx.writeBuffer().then((data) => {
          let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          fs.saveAs(blob, fileName);
        });
        this.exceldownloadtrue = false;
        this.stopexportapi = true;
        this.itemOffset = 0;
        this.progressbarCount = '0';
        this.progressbarCountWidth = this.progressbarCount + '%';
        this.downloadtextflag = 'Exporting data to Excel..';
        this.updateonExportisDone.emit(1);
      }, 3000);
    } else {
      this.getUserDashboard();
    }


  }


  exportDiagnosticReport(access, title, exportData) {
    console.log(exportData)
    let apiData = exportData;
    let headers = ['Module', 'Module Abbreviation', 'Module Description', 'DTC', 'Description', 'Diagnostic Instruction'];
    apiData.forEach(data => {
      let diagnosticInfo: any = [];
      let infoItems = data.infoItems;
      if(infoItems.length == 0) {
        diagnosticInfo = [data.name, data.slug, data.desc, '', '', ''];
        this.diagnosticInfo.push(diagnosticInfo);
      } else {
        infoItems.forEach(item => {
          diagnosticInfo = [data.name, data.slug, data.desc, item.dtcCode, item.dtcDesc, item.instruction];
          this.diagnosticInfo.push(diagnosticInfo);
        });
      }
    });

    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet(title);
    let headerRow = worksheet.addRow(headers);

    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'e8e3e3' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' } }
    });

    this.diagnosticInfo.forEach(l => {
      let row = worksheet.addRow(l);
      let qty = row.getCell(100);
      let color = 'FFFFFF';
      if (+qty.value < 500) {
        color = 'FFFFFF'
      }
      qty.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: color }
      }
    });

    worksheet.getColumn(1).width = 35;
    worksheet.getColumn(2).width = 20;
    worksheet.getColumn(3).width = 40;
    worksheet.getColumn(4).width = 20;
    worksheet.getColumn(5).width = 75;
    worksheet.getColumn(6).width = 30;
    worksheet.addRow([]);

    if (this.exceldownloadtrue) {
      this.progressbarCount = '100';
      this.progressbarCountWidth = this.progressbarCount + '%';
      this.downloadtextflag = 'Export complete.';
      let date = '';
      if (this.apiData.hasOwnProperty('uploadedOn')) {
        let uploadedDate = this.apiData.uploadedOn;
        date = (uploadedDate == '-') ? date : moment(uploadedDate).format('MMM DD, YYYY');
      }
      let fname = (access == 'diagnostic') ? `${this.apiData.fileName} Module` : 'Module Template';
      let fileName = (access == 'diagnostic') ? `${fname} ${date}.xlsx` : `${fname}.xlsx`;
      setTimeout(() => {
        //Generate Excel File with given name
        workbook.xlsx.writeBuffer().then((data) => {
          let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          fs.saveAs(blob, fileName);
        });
        this.exceldownloadtrue = false;
        this.stopexportapi = true;
        this.itemOffset = 0;
        this.progressbarCount = '0';
        this.progressbarCountWidth = this.progressbarCount + '%';
        this.downloadtextflag = 'Exporting data to Excel..';
        this.updateonExportisDone.emit(1);
      }, 3000);
    } else {
      this.getDiagnosticExcelData();
    }
  }

  exportCustomersReport(title) {
    let headers = ['First Name', 'Last Name', 'Email', 'Company', 'Phone', 'Address 1', 'Address 2', 'Country', 'State', 'City', 'Zip'];
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet(title);
    let headerRow = worksheet.addRow(headers);

    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'e8e3e3' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' } }
    });

    worksheet.getColumn(1).width = 20;
    worksheet.getColumn(2).width = 20;
    worksheet.getColumn(3).width = 30;
    worksheet.getColumn(4).width = 20;
    worksheet.getColumn(5).width = 30;
    worksheet.getColumn(6).width = 20;
    worksheet.getColumn(7).width = 20;
    worksheet.getColumn(8).width = 20;
    worksheet.getColumn(9).width = 20;
    worksheet.getColumn(10).width = 20;
    worksheet.getColumn(11).width = 20;
    worksheet.addRow([]);

    if (this.exceldownloadtrue) {
      this.progressbarCount = '100';
      this.progressbarCountWidth = this.progressbarCount + '%';
      this.downloadtextflag = 'Export complete.';
      let fname = `${this.apiData.fileName}`;
      let fileName = `${fname}.xlsx`;
      setTimeout(() => {
        workbook.xlsx.writeBuffer().then((data) => {
          let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          fs.saveAs(blob, fileName);
        });
        this.exceldownloadtrue = false;
        this.stopexportapi = true;
        this.itemOffset = 0;
        this.progressbarCount = '0';
        this.progressbarCountWidth = this.progressbarCount + '%';
        this.downloadtextflag = 'Exporting data to Excel..';
        this.updateonExportisDone.emit(1);
      }, 3000);
    } else {
      this.getDiagnosticExcelData();
    }
  }

  exportAdasReport(access, title, exportData) {
    console.log(exportData)
    let apiData = exportData;
    let headers = ['Make', 'Model', 'Year', 'Equipment'];
    let appendCol1 = 'Calibration Name';
    let appendCol2 = 'Calibration Instruction';
    let appendCol3 = 'Internal Notes';
    let appendHeaders = [appendCol1, appendCol2, appendCol3];
    if(access == 'adas-template') {
      let appendCount = 5;
      for(let i=0; i<appendCount; i++) {
        headers = headers.concat(appendHeaders);
      }
    }
    apiData.forEach((data, aindex) => {
      let adasInfo: any = [];
      let infoItems = data.contItems;
      adasInfo = [data.make, data.model, parseInt(data.year), data.equipmentStr];
      if(infoItems.length == 0) {
        this.adasInfo.push(adasInfo);
      } else {
        infoItems.forEach((item, index) => {
          let checkCount = 4;
          let colCount = 3;
          colCount = (index == 0) ? checkCount : colCount;
          let itemIndex = (index * colCount)+checkCount;
          let colIndex1 = itemIndex+0;
          let colIndex2 = itemIndex+1;
          let colIndex3 = itemIndex+2;
          headers[colIndex1] = appendCol1;
          headers[colIndex2] = appendCol2;
          headers[colIndex3] = appendCol3;
          adasInfo[colIndex1] = item.adasName;
          adasInfo[colIndex2] = item.realDescription;
          adasInfo[colIndex3] = item.realNotes;
        });
        this.adasInfo.push(adasInfo);
      }
    });

    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet(title);
    let headerRow = worksheet.addRow(headers);

    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'e8e3e3' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' } }
    });

    this.adasInfo.forEach(l => {
      let row = worksheet.addRow(l);
      let qty = row.getCell(100);
      let color = 'FFFFFF';
      if (+qty.value < 500) {
        color = 'FFFFFF'
      }
      qty.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: color }
      }
    });

    headers.forEach((item, index) => {
      let width = (index > 2) ? 25 : 10;
      worksheet.getColumn(index+1).width = width;
    })
    /* worksheet.getColumn(1).width = 35;
    worksheet.getColumn(2).width = 20;
    worksheet.getColumn(3).width = 40;
    worksheet.getColumn(4).width = 20;
    worksheet.getColumn(5).width = 75;
    worksheet.getColumn(6).width = 30; */
    worksheet.addRow([]);

    if (this.exceldownloadtrue) {
      this.progressbarCount = '100';
      this.progressbarCountWidth = this.progressbarCount + '%';
      this.downloadtextflag = 'Export complete.';
      let date = '';
      if (this.apiData.hasOwnProperty('uploadedOn')) {
        let uploadedDate = this.apiData.uploadedOn;
        date = (uploadedDate == '-') ? date : moment(uploadedDate).format('MMM DD, YYYY');
      }
      let fname = (access == 'adas') ? `${this.apiData.fileName} Vehicle` : 'Vehicle Template';
      let fileName = (access == 'adas') ? `${fname} ${date}.xlsx` : `${fname}.xlsx`;
      setTimeout(() => {
        //Generate Excel File with given name
        workbook.xlsx.writeBuffer().then((data) => {
          let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          fs.saveAs(blob, fileName);
        });
        this.exceldownloadtrue = false;
        this.stopexportapi = true;
        this.itemOffset = 0;
        this.progressbarCount = '0';
        this.progressbarCountWidth = this.progressbarCount + '%';
        this.downloadtextflag = 'Exporting data to Excel..';
        this.updateonExportisDone.emit(1);
      }, 3000);
    } else {
      this.getDiagnosticExcelData();
    }
  }

  // Export Diagnostic Data
  getDiagnosticExcelData() {
    this.apiData['limit'] = this.itemLimit;
    this.apiData['offset'] = this.itemOffset;
    this.apiData['listType'] = 'download';
    this.uploadFlag = this.LandingpagewidgetsAPI.getStandardReportlistsAPI(this.apiData).subscribe((response) => {
      this.apiData['listType'] = '';
      let responseData = response.data;
      let exportData = responseData.items;
      let totalCount = responseData.total;
      this.totalLimit = totalCount;
      this.itemLength += totalCount;
      this.itemOffset += this.itemLimit;
      let minRowCount = 1;
      this.progressbarCount = (this.itemOffset > totalCount) ? (minRowCount*100).toFixed() : ((this.itemOffset / totalCount) * 100).toFixed(0);
      this.progressbarCountWidth = this.progressbarCount + '%';
      if (totalCount == 0) {
      }
      else {
        if (this.stopexportapi) {
          console.log('in')
          if (this.itemOffset >= this.totalLimit) {
            this.exceldownloadtrue = true;;
          }
          this.generateExcel(this.access, this.exportInfo, exportData);
        }
        if (this.itemOffset >= this.totalLimit) {
          this.stopexportapi = false;
        }
      }
    });
  }

  // Export Adas Data
  getAdasExcelData() {
    this.apiData['limit'] = this.itemLimit;
    this.apiData['offset'] = this.itemOffset;
    this.apiData['listType'] = 'download';
    this.uploadFlag = this.LandingpagewidgetsAPI.getStandardReportlistsAPI(this.apiData).subscribe((response) => {
      this.apiData['listType'] = '';
      let responseData = response.data;
      let exportData = responseData.items;
      let totalCount = responseData.total;
      this.totalLimit = totalCount;
      this.itemLength += totalCount;
      this.itemOffset += this.itemLimit;
      let minRowCount = 1;
      this.progressbarCount = (this.itemOffset > totalCount) ? (minRowCount*100).toFixed() : ((this.itemOffset / totalCount) * 100).toFixed(0);
      this.progressbarCountWidth = this.progressbarCount + '%';
      if (totalCount == 0) {
      }
      else {
        if (this.stopexportapi) {
          console.log('in')
          if (this.itemOffset >= this.totalLimit) {
            this.exceldownloadtrue = true;;
          }
          this.generateExcel(this.access, this.exportInfo, exportData);
        }
        if (this.itemOffset >= this.totalLimit) {
          this.stopexportapi = false;
        }
      }
    });
  }

  myStyle(): object {
    return { "width": this.progressbarCountWidth };
  }
  cancelUpload() {
    if(  this.access == 'thread-solr-export' || this.access == 'thread-solr-export-new' || this.access == 'export-sr' || this.access == 'export-business' || this.access == 'summary-today' || this.access == 'techsupport-tickets' || this.access == 'gbb-jobs' || this.access == 'gbb-jobs-type-4' || this.access == 'summary-weekly' || this.access == 'dealerUsage'){
      if(this.uploadFlag){
        this.uploadFlag.unsubscribe();
      }
      this.updateonExportisDone.emit(1);
    }else{
      if(this.uploadFlag){
        this.uploadFlag.unsubscribe();
      }
      this.downloadtextflag = 'Canceling Export';
      this.exceldownloadtrue = false;
      this.stopexportapi = true;
      this.itemOffset = 0;
      this.threadLists = [];
      this.progressbarCount = '0';
      setTimeout(() => {
        this.updateonExportisDone.emit(1);
      }, 2000);
    }
    
  }
  closeUpload(){
    if(this.uploadFlag){
      this.uploadFlag.unsubscribe();
    }
    this.downloadUrl = '';
    this.downloadUrlFlag = false;
    this.updateonExportisDone.emit(1);
  }

  closeUploadNew(){    
    this.updateonExportisDone.emit(1);
  }

  cancelGBBUpload() {
    if(this.uploadFlag){
      this.uploadFlag.unsubscribe();
    }
    this.updateonExportisDone.emit('close');
  }
  closeGbbReport(){    
    this.updateonExportisDone.emit({url: this.downloadUrl});
  }

  setItemSpace(value)
  {

    return value.map(e => e).join(", ");

  }
}
